import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { Patient } from '../../../model/user/Patient';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState, selectDoctorState } from '../../../store/app.states';
import { GetPatients } from '../../../store/actions/doctor.actions';
import { ErrorDialogComponent } from '../../user-actions/error-dialog/error-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { StatForm } from '../../../model/user/StatForm';
import { DoctorService } from '../../../services/doctor.service';
import * as _moment from 'moment';
// import moment from 'moment';
// @ts-ignore
import { default as _rollupMoment } from 'moment';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Therapy } from '../../../model/user/Therapy';
import { ClinicalData } from '../../../model/user/ClinicalData';
import { InfoClinicalDialogComponent } from '../../user-actions/info-clinical-dialog/info-clinical-dialog.component';
import { Note } from '../../../model/user/Note';
import * as clinicalDataFile from '../../../../assets/clinicalData.json';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Therapy2 } from '../../../model/user/Therapy2';
import { ConfirmDialogMultilinesComponent } from '../../user-actions/confirm-dialog-multilines/confirm-dialog-multilines.component';
import { PatientBodyStat } from 'src/app/model/user/PatientBodyStat';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
const moment = _rollupMoment || _moment;

@Component({
  selector: 'app-patient-panel',
  templateUrl: './patient-panel.component.html',
  styleUrls: ['./patient-panel.component.css']
})
export class PatientPanelComponent implements OnInit, OnDestroy {
  // subscriptions
  subscription1: Subscription;
  subscription2: Subscription;
  //
  patientSSN: string;
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  //// user state
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  // panel
  patient: Patient;
  patientBodyStat: PatientBodyStat;
  title = 'Scheda paziente';
  destination: string;
  editing = false;
  editing_birthDate = false;
  statForm: FormGroup;
  notFocused = false;
  sexOptions = ['Donna', 'Uomo', 'Altro'];
  options = ['si', 'no'];
  localization = ['Proctite', 'Colite sinistra', 'Pancolite'];
  storiche = ['si, qualsiasi numero', 'no'];
  pathologies = ['Malattia di Crohn', 'Colite ulcerosa', 'Altro'];
  otherPathology = false;
  isPatientCrohn = false;
  isPatientUC = true;
  // column's titles
  public firstColumnTitle = 'Dati clinici di base';
  public secondColumnTitle = 'Dati specifici della malattia';
  public thirdColumnTitle = 'Interventi e Terapia';
  // panel
  panelOpenNotes = false;
  panelOpenTherapies = false;
  panelOpenInfiammatorio = false;
  panelOpenStenosante = false;
  panelOpenPenetrante = false;
  panelOpenMalPeri = false;
  panelOpenTerapia5 = false;
  panelOpenTerapiaGcs = false;
  panelOpenTerapiaBio = false;
  panelOpenTerapiaTop = false;
  panelOpenTerapiaImm = false;
  panelOpenUC = false;
  panelOpenStoriche = false;
  panelOpenAttive = false;
  panelOpenStomia = false;
  panelOpenLocatC = false;
  panelOpenLocatI = false;
  panelOpenLocatGI = false;
  panelOpenLocatUC = false;
  //
  // inizializzazione degli ultimi valori inseriti che appaiono all'inserimento
  // dei dati clinici come default
  lastSex: string;
  lastFamiliarity: string;
  lastInfiammatorio: string;
  lastStenosante: string;
  lastPenentrante: string;
  lastMalattiaPeri: string;
  lastLocatC: string;
  lastLocatI: string;
  lastLocatUpperGI: string;
  lastLocalizzazioneUC: string;
  lastEIMSstoriche: string;
  lastEIMSAttive: string;
  lastInterventi: string;
  lastStomia: string;
  lastTerapia5ASA: string;
  lastTopica: string;
  lastGCS: string;
  lastBIO: string;
  lastIMM: string;
  clinicalDataFile: any;
  therapy = new Therapy('', '');
  // per cd
  infiammatorioCDValue = new ClinicalData('', '', '');
  stenosanteCDValue = new ClinicalData('', '', '');
  penetranteCDValue = new ClinicalData('', '', '');
  malattiaPerianaleCDValue = new ClinicalData('', '', '');
  locatColonCDValue = new ClinicalData('', '', '');
  locatIleumCDValue = new ClinicalData('', '', '');
  locatUpperGIValue = new ClinicalData('', '', '');
  // per UC e IBD_U
  localizzazioneUCValue = new ClinicalData('', '', '');
  // per tutti
  storicheEIMSValue = new ClinicalData('', '', '');
  attiveEIMSValue = new ClinicalData('', '', '');
  stomiaValue = new ClinicalData('', '', '');
  // terapia: inizializzazione dei valori che vengono inseriti
  fiveASAOSValue = new Therapy2('', '', '', '');
  topicaValue = new Therapy2('', '', '', '');
  gcsOSValue = new Therapy2('', '', '', '');
  immValue = new Therapy2('', '', '', '');
  bioValue = new Therapy2('', '', '', '');
  // variabili per il selezionamento delle date per
  // le variabili cliniche
  isAltraDataCheckedInfiammatorio = false;
  isDiagnosiDateCheckedInfiammatorio = true;
  isAltraDataCheckedStenosante = false;
  isDiagnosiDateCheckedStenosante = true;
  isAltraDataCheckedPenetrante = false;
  isDiagnosiDateCheckedPenetrante = true;
  isAltraDataCheckedMalPeri = false;
  isDiagnosiDateCheckedMalPeri = true;
  isAltraDataCheckedLocatColon = false;
  isDiagnosiDateCheckedLocatColon = true;
  isAltraDataCheckedLocatIleum = false;
  isDiagnosiDateCheckedLocatIleum = true;
  isAltraDataCheckedLocatUpper = false;
  isDiagnosiDateCheckedLocatUpper = true;
  isAltraDataCheckedLocUC = false;
  isDiagnosiDateCheckedLocUC = true;
  isAltraDataCheckedStoriche = false;
  isDiagnosiDateCheckedStoriche = true;
  isDiagnosiDateCheckedAttive = true;
  isAltraDataCheckedAttive = false;
  isDiagnosiDateCheckedStomia = true;
  isAltraDataCheckedStomia = false;
  // variabili per la terapia 5ASAOS
  fiveASAOSpast = false;
  fiveASAOSpresent = false;
  // variabili per la terapia topica
  topicaPast = false;
  topicaPresent = false;
  // variabili per la terapia imm
  immPast = false;
  immPresent = false;
  // variabili per la terapia bio
  bioPast = false;
  bioPresent = false;
  // variabili per la terapia gcs
  gcsPast = false;
  gcsPresent = false;
  // per il set della data rispetto all'ultimo valore inserito
  altraDataInf: string;
  altraDataSte: string;
  altraDataPen: string;
  altraDataMalPeri: string;
  altraDataLocatColon: string;
  altraDataLocatIleum: string;
  altraDataLocatUpper: string;
  altraDataLocUC: string;
  altraDataStomia: string;
  altraDataStoriche: string;
  altraDataAttive: string;
  // variabili che servono per far comparire o meno le selezioni della data
  infiammatorioYes: boolean;
  stenosanteYes: boolean;
  penetranteYes: boolean;
  malperiYes: boolean;
  locatColonYes: boolean;
  locatIleumYes: boolean;
  locatUpperYes: boolean;
  attiveYes: boolean;
  storicheYes: boolean;
  stomiaYes: boolean;
  // last variables per terapia che compaiono di default
  last5ASAOSpast: string;
  last5ASAOSpresent: string;
  lastDateOfStart5ASA: string;
  lastGCSOSpast: string;
  lastGCSOSpresent: string;
  lastDateOfStartGCS: string;
  lastTOPICApast: string;
  lastTOPICApresent: string;
  lastDateOfStartTOPICA: string;
  lastBIOpast: string;
  lastBIOpresent: string;
  lastDateOfStartBIO: string;
  lastIMMpast: string;
  lastIMMpresent: string;
  lastDateOfStartIMM: string;
  showSpinner = false;
  showButton = true;
  confirmValue = false;
  formToSend: any;
  newBirthDate = null;
  // stringa per il messaggio di conferma
  private riepilogo: string[];

  constructor(private router: Router,
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private doctorService: DoctorService) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
    this.route.params.subscribe(params => {
      this.patientSSN = params.ssn;
      if (params.back.localeCompare('global') === 0) {
        this.destination = 'patients-global-control-panel';
      } else if (params.back.localeCompare('inactive-patients-summary') === 0) {
        const doctorID = JSON.parse(localStorage.getItem('doctorID'));
        this.destination = 'inactive-patients-summary/' + doctorID;
      } else if (params.back.localeCompare('doctor-chat') === 0) {
        this.destination = 'doctor-chat/';
      } else if (params.back.localeCompare('general-status') === 0) {
        this.destination = 'general-status';
      } else {
        this.destination = 'patients-control-panel';
      }
    });


    document.addEventListener('notification', () => {
      this.store.dispatch(new GetPatients());
    });
    this.initializeStatForm();
    this.doctorService.getBodyStatPatient(this.patientSSN).subscribe((patientBodyStat) => {
      this.patientBodyStat = patientBodyStat;
      this.initialization();
    }, error => {
      console.log('ERROR LOADING BOADY STAT');
      location.reload();
    });
  }

  initializeStatForm() {
    this.statForm = new FormGroup({
      category: new FormControl("", [Validators.required]),
      weight: new FormControl("", [Validators.required, Validators.min(0), Validators.max(300)]),
      height: new FormControl("", [Validators.required, Validators.min(0), Validators.max(250)]),
      age: new FormControl("", [Validators.required, Validators.min(0), Validators.max(150)]),
      sex: new FormControl("", [Validators.required]),
      dateOfDiagnosis: new FormControl("", [Validators.required]),
      ageOfDiagnosis: new FormControl("", [Validators.required, Validators.min(0), Validators.max(150)]),
      familiarity: new FormControl("", [Validators.required]),
      pathologyDuration: new FormControl("", [Validators.required, Validators.min(0),
      Validators.max(150)]),
      pathology: new FormControl("", [Validators.required]),
      // per CD
      infiammatorioCD: new FormControl("", []),
      stenosanteCD: new FormControl("", []),
      penetranteCD: new FormControl("", []),
      malattiaPerianaleCD: new FormControl("", []),
      locatColonCD: new FormControl("", []),
      locatIleumCD: new FormControl("", []),
      locatUpperGI: new FormControl("", []),
      // solo per uc e altro
      localizzazioneUC: new FormControl("", []),
      //
      storicheEIMS: new FormControl("", [Validators.required]),
      attiveEIMS: new FormControl("", [Validators.required]),
      interventi: new FormControl("", [Validators.required]),
      numResezioni: new FormControl("", [Validators.required]),
      stomia: new FormControl("", [Validators.required]),
      // terapia
      therapy5ASAOS: new FormControl("", []),
      therapyTOPICA: new FormControl("", []),
      therapyGCSOS: new FormControl("", []),
      therapyIMM: new FormControl("", []),
      therapyBIO: new FormControl("", []),
      notes: new FormControl('', []),
      // therapy: new FormControl(this.patient.bodyStat.therapy, [])
      therapies: new FormControl('', []),
    });
  }
  ngOnInit(): void {


    // patients si riferisce alla lista dei pazienti riferiti al dottore
    //const patients: Patient[] = JSON.parse(localStorage.getItem('patients'));
    //this.patient = patients.find(p => p.ssn.localeCompare(this.patientSSN) === 0);
    this.doctorService.getPatient(this.patientSSN).subscribe(data => {
      data.birthDate = data.birthDate.split("-")[2] + "/" + data.birthDate.split("-")[1] + "/" + data.birthDate.split("-")[0];
      this.patient = data;
      console.log(this.patient);
    });

    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      console.log(this.user);
      this.errorMessage = state.errorMessage;
      console.log(state.user);
    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    });
    // Inizializzazione della form da compilare
    this.statForm = new FormGroup({
      category: new FormControl(this.patient.category, [Validators.required]),
      weight: new FormControl(this.patientBodyStat.bodyStat.weight, [Validators.required, Validators.min(0), Validators.max(300)]),
      height: new FormControl(this.patientBodyStat.bodyStat.height, [Validators.required, Validators.min(0), Validators.max(250)]),
      age: new FormControl(this.patientBodyStat.bodyStat.age, [Validators.required, Validators.min(0), Validators.max(150)]),
      sex: new FormControl(this.patientBodyStat.bodyStat.sex, [Validators.required]),
      dateOfDiagnosis: new FormControl(this.patientBodyStat.bodyStat.dateOfDiagnosis, [Validators.required]),
      ageOfDiagnosis: new FormControl(this.patientBodyStat.bodyStat.ageOfDiagnosis, [Validators.required, Validators.min(0), Validators.max(150)]),
      familiarity: new FormControl(this.patientBodyStat.bodyStat.familiarity, [Validators.required]),
      pathologyDuration: new FormControl(this.patientBodyStat.bodyStat.pathologyDuration, [Validators.required, Validators.min(0),
      Validators.max(150)]),
      pathology: new FormControl(this.patientBodyStat.bodyStat.pathology, [Validators.required]),
      // per CD
      infiammatorioCD: new FormControl(this.infiammatorioCDValue, []),
      stenosanteCD: new FormControl(this.stenosanteCDValue, []),
      penetranteCD: new FormControl(this.penetranteCDValue, []),
      malattiaPerianaleCD: new FormControl(this.malattiaPerianaleCDValue, []),
      locatColonCD: new FormControl(this.locatColonCDValue, []),
      locatIleumCD: new FormControl(this.locatIleumCDValue, []),
      locatUpperGI: new FormControl(this.locatUpperGIValue, []),
      // solo per uc e altro
      localizzazioneUC: new FormControl(this.localizzazioneUCValue, []),
      //
      storicheEIMS: new FormControl(this.storicheEIMSValue, [Validators.required]),
      attiveEIMS: new FormControl(this.attiveEIMSValue, [Validators.required]),
      interventi: new FormControl(this.patientBodyStat.bodyStat.interventi, [Validators.required]),
      numResezioni: new FormControl(this.patientBodyStat.bodyStat.numResezioni, [Validators.required]),
      stomia: new FormControl(this.stomiaValue, [Validators.required]),
      // terapia
      therapy5ASAOS: new FormControl(this.fiveASAOSValue, []),
      therapyTOPICA: new FormControl(this.topicaValue, []),
      therapyGCSOS: new FormControl(this.gcsOSValue, []),
      therapyIMM: new FormControl(this.immValue, []),
      therapyBIO: new FormControl(this.bioValue, []),
      notes: new FormControl('', []),
      // therapy: new FormControl(this.patient.bodyStat.therapy, [])
      therapies: new FormControl('', []),
    });

  }

  initialization() {
    console.log(this.patient);
    console.log(this.patientBodyStat);
    // inizializzazione e ordinamento in base alla data
    if (this.patientBodyStat.bodyStat.notes === null) {
      this.patientBodyStat.bodyStat.notes = [];
    } else {
      this.patientBodyStat.bodyStat.notes = this.patientBodyStat.bodyStat.notes.slice().sort((n1, n2) => this.comparing(n1, n2));
    }
    if (this.patientBodyStat.bodyStat.therapies === null) {
      this.patientBodyStat.bodyStat.therapies = [];
    } else {
      this.patientBodyStat.bodyStat.therapies = this.patientBodyStat.bodyStat.therapies.slice().sort((n1, n2) => this.comparing(n1.date, n2.date));
    }
    if (this.patientBodyStat.bodyStat.infiammatorioCD === null) {
      this.patientBodyStat.bodyStat.infiammatorioCD = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.infiammatorioCD = this.patientBodyStat.bodyStat.infiammatorioCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.stenosanteCD === null) {
      this.patientBodyStat.bodyStat.stenosanteCD = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.stenosanteCD = this.patientBodyStat.bodyStat.stenosanteCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.penetranteCD === null) {
      this.patientBodyStat.bodyStat.penetranteCD = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.penetranteCD = this.patientBodyStat.bodyStat.penetranteCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.malattiaPerianaleCD === null) {
      this.patientBodyStat.bodyStat.malattiaPerianaleCD = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.malattiaPerianaleCD = this.patientBodyStat.bodyStat.malattiaPerianaleCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.locatColonCD === null) {
      this.patientBodyStat.bodyStat.locatColonCD = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.locatColonCD = this.patientBodyStat.bodyStat.locatColonCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.locatIleumCD === null) {
      this.patientBodyStat.bodyStat.locatIleumCD = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.locatIleumCD = this.patientBodyStat.bodyStat.locatIleumCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.locatUpperGI === null) {
      this.patientBodyStat.bodyStat.locatUpperGI = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.locatUpperGI = this.patientBodyStat.bodyStat.locatUpperGI.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.localizzazioneUC === null) {
      this.patientBodyStat.bodyStat.localizzazioneUC = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.localizzazioneUC = this.patientBodyStat.bodyStat.localizzazioneUC.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.storicheEIMS === null) {
      this.patientBodyStat.bodyStat.storicheEIMS = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.storicheEIMS = this.patientBodyStat.bodyStat.storicheEIMS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.attiveEIMS === null) {
      this.patientBodyStat.bodyStat.attiveEIMS = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.attiveEIMS = this.patientBodyStat.bodyStat.attiveEIMS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.stomia === null) {
      this.patientBodyStat.bodyStat.stomia = [];
    } else {
      this.patientBodyStat.bodyStat.stomia = this.patientBodyStat.bodyStat.stomia.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }
    // MOMENTANEMAENTE SOSPESA L'ORDINAMENTO DELLE TERAPIE SULLA BASE DELLA DATA
    // QUESTO PERCHE' SE USO THERAPY2 E DATEOFSTART IN ALCUNI CASI è null, QUANDO
    // LA TERAPIA NON E' MAI STATA CONDOTTA; SI POTREBBE RISOLVERE
    // METTENDO UNA VOCE DI INSERIMENTO DEL DATO E ORDINARE RISPETTO A QUELLA -> FATTO!
    if (this.patientBodyStat.bodyStat.therapy5ASAOS === null) {
      this.patientBodyStat.bodyStat.therapy5ASAOS = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapy5ASAOS = this.patientBodyStat.bodyStat.therapy5ASAOS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.therapyTOPICA === null) {
      this.patientBodyStat.bodyStat.therapyTOPICA = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapyTOPICA = this.patientBodyStat.bodyStat.therapyTOPICA.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.therapyGCSOS === null) {
      this.patientBodyStat.bodyStat.therapyGCSOS = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapyGCSOS = this.patientBodyStat.bodyStat.therapyGCSOS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.therapyIMM === null) {
      this.patientBodyStat.bodyStat.therapyIMM = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapyIMM = this.patientBodyStat.bodyStat.therapyIMM.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }

    if (this.patientBodyStat.bodyStat.therapyBIO === null) {
      this.patientBodyStat.bodyStat.therapyBIO = [];
    } else {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapyBIO = this.patientBodyStat.bodyStat.therapyBIO.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
    }
    // questo ciclo serve per abilitare la visibilità di alcune veriabili cliniche piuttosto che altre
    if (this.patientBodyStat.bodyStat.pathology === 'Malattia di Crohn') {
      this.isPatientCrohn = true;
      this.isPatientUC = false;
    } else if (this.patientBodyStat.bodyStat.pathology === 'Colite ulcerosa') {
      this.isPatientCrohn = false;
      this.isPatientUC = true;
    }
    // stringhe che servono per impostare nella form di default l'ultimo valore inserito
    this.lastSex = this.convertValueSex(this.patientBodyStat.bodyStat.sex);
    // prendo come valore quello che si riferisce alla data più recente
    this.lastFamiliarity = this.convertValue(this.patientBodyStat.bodyStat.familiarity);
    this.lastInfiammatorio = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.infiammatorioCD));
    this.lastPenentrante = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.penetranteCD));
    this.lastStenosante = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.stenosanteCD));
    this.lastMalattiaPeri = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.malattiaPerianaleCD));
    this.lastLocatC = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.locatColonCD));
    this.lastLocatI = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.locatIleumCD));
    this.lastLocatUpperGI = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.locatUpperGI));
    this.lastLocalizzazioneUC = this.convertValueLocalizzazioneUC(this.getLastValue(this.patientBodyStat.bodyStat.localizzazioneUC));
    this.lastEIMSstoriche = this.convertValueStoriche(this.getLastValue(this.patientBodyStat.bodyStat.storicheEIMS));
    this.lastEIMSAttive = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.attiveEIMS));
    this.lastStomia = this.convertValue(this.getLastValue(this.patientBodyStat.bodyStat.stomia));
    // // anche per le terapie si prendono come valore di default le selezioni più recenti
    // ANCHE QUI NON METTO ALCUN VALORE DI DEFAULT PER LE TERAPIE
    // this.lastTerapia5ASA = this.convertValue(this.getLastValue(this.patient.bodyStat.therapy5ASAOS));
    // this.lastTopica = this.convertValue(this.getLastValue(this.patient.bodyStat.topica));
    // this.lastGCS = this.convertValue(this.getLastValue(this.patient.bodyStat.gcsOS));
    // this.lastBIO = this.convertValue(this.getLastValue(this.patient.bodyStat.bio));
    // this.lastIMM = this.convertValue(this.getLastValue(this.patient.bodyStat.imm));
    this.lastInterventi = this.convertValue(this.patientBodyStat.bodyStat.interventi);

  }

  ngOnDestroy() {
    this.subscription1.unsubscribe();
  }

  /*// selezione della patologia
  selectResult($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value.localeCompare('Altro') !== 0) {
        this.statForm.get('pathology').setValue(value);
        this.otherPathology = false;
      } else {
        this.statForm.get('pathology').setValue('');
        this.otherPathology = true;
      }
      console.log(this.statForm.get('pathology').value);
    }
  }*/
  // FUNZIONI CHE SI ESEGUONO QUANDO PER TRASFORMARE IN VALORI 0/1 O COMUNQUE
  // NELLA GIUSTA FORMA PER IMMAGAZZINARE I DATI
  // selezione della patologia
  selectResult($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      this.statForm.get('pathology').setValue(value);
    }
  }

  // selezione della familiarità
  selectFamiliarity($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('familiarity').setValue('1');
      } else {
        this.statForm.get('familiarity').setValue('0');
      }
    }
  }

  // selezione del sesso
  selectSexOptions($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'Donna') {
        this.statForm.get('sex').setValue('1');
      } else if (value === 'Uomo') {
        this.statForm.get('sex').setValue('2');
      } else {
        this.statForm.get('sex').setValue('3');
      }
    }
  }

  selectInfiammatorio($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('infiammatorioCD').setValue('1');
        this.infiammatorioYes = true;
        this.infiammatorioCDValue.value = '1';
        if (this.infiammatorioCDValue.date === '' || this.infiammatorioCDValue.date === null) {
          this.isDiagnosiDateCheckedInfiammatorio = true;
          this.infiammatorioCDValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('infiammatorioCD').setValue('0');
        this.infiammatorioYes = false;
        this.isDiagnosiDateCheckedInfiammatorio = false;
        this.isAltraDataCheckedInfiammatorio = false;
        this.infiammatorioCDValue.value = '0';
        // la data di riferimento del valore è vuota perchè è 'no'
        this.infiammatorioCDValue.date = null;
      }
    }
  }

  selectStenosante($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('stenosanteCD').setValue('1');
        this.stenosanteYes = true;
        this.stenosanteCDValue.value = '1';
        if (this.stenosanteCDValue.date === '' || this.stenosanteCDValue.date === null) {
          this.isDiagnosiDateCheckedStenosante = true;
          this.stenosanteCDValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('stenosanteCD').setValue('0');
        this.stenosanteYes = false;
        this.isDiagnosiDateCheckedStenosante = false;
        this.isAltraDataCheckedStenosante = false;
        this.stenosanteCDValue.value = '0';
        this.stenosanteCDValue.date = null;
      }
    }
  }

  selectPenetrante($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('penetranteCD').setValue('1');
        this.penetranteYes = true;
        this.penetranteCDValue.value = '1';
        if (this.penetranteCDValue.date === '' || this.penetranteCDValue.date === null) {
          this.isDiagnosiDateCheckedPenetrante = true;
          this.penetranteCDValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('penetranteCD').setValue('0');
        this.penetranteYes = false;
        this.isDiagnosiDateCheckedPenetrante = false;
        this.isAltraDataCheckedPenetrante = false;
        this.penetranteCDValue.value = '0';
        this.penetranteCDValue.date = null;
      }
    }
  }

  selectMalattiaPerianale($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('malattiaPerianaleCD').setValue('1');
        this.malperiYes = true;
        this.malattiaPerianaleCDValue.value = '1';
        if (this.malattiaPerianaleCDValue.date === '' || this.malattiaPerianaleCDValue.date === null) {
          this.isDiagnosiDateCheckedMalPeri = true;
          this.malattiaPerianaleCDValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('malattiaPerianaleCD').setValue('0');
        this.malperiYes = false;
        this.isDiagnosiDateCheckedMalPeri = false;
        this.isAltraDataCheckedMalPeri = false;
        this.malattiaPerianaleCDValue.value = '0';
        this.malattiaPerianaleCDValue.date = null;
      }
    }
  }

  selectLocatColon($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('locatColonCD').setValue('1');
        this.locatColonYes = true;
        this.locatColonCDValue.value = '1';
        if (this.locatColonCDValue.date === '' || this.locatColonCDValue.date === null) {
          this.isDiagnosiDateCheckedLocatColon = true;
          this.locatColonCDValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('locatColonCD').setValue('0');
        this.locatColonYes = false;
        this.isDiagnosiDateCheckedLocatColon = false;
        this.isAltraDataCheckedLocatColon = false;
        this.locatColonCDValue.value = '0';
        this.locatColonCDValue.date = null;
      }
    }
  }

  selectLocalIleum($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('locatIleumCD').setValue('1');
        this.locatIleumYes = true;
        this.locatIleumCDValue.value = '1';
        if (this.locatIleumCDValue.date === '' || this.locatIleumCDValue.date === null) {
          this.isDiagnosiDateCheckedLocatIleum = true;
          this.locatIleumCDValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('locatIleumCD').setValue('0');
        this.locatIleumYes = false;
        this.isDiagnosiDateCheckedLocatIleum = false;
        this.isAltraDataCheckedLocatIleum = false;
        this.locatIleumCDValue.value = '0';
        this.locatIleumCDValue.date = null;
      }
    }
  }

  selectUpperGI($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('locatUpperGI').setValue('1');
        this.locatUpperYes = true;
        this.locatUpperGIValue.value = '1';
        if (this.locatUpperGIValue.date === '' || this.locatUpperGIValue.date === null) {
          this.isDiagnosiDateCheckedLocatUpper = true;
          this.locatUpperGIValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('locatUpperGI').setValue('0');
        this.locatUpperYes = false;
        this.isDiagnosiDateCheckedLocatUpper = false;
        this.isAltraDataCheckedLocatUpper = false;
        this.locatUpperGIValue.value = '0';
        this.locatUpperGIValue.date = null;
      }
    }
  }

  selectLocalizzazioneUC($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'Proctite') {
        this.statForm.get('localizzazioneUC').setValue('1');
      } else if (value === 'Colite sinistra') {
        this.statForm.get('localizzazioneUC').setValue('2');
      } else {
        this.statForm.get('localizzazioneUC').setValue('3');
      }
      this.localizzazioneUCValue.value = this.statForm.value.localizzazioneUC;
    }
  }

  selectStoricalEIMS($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'no') {
        this.statForm.get('storicheEIMS').setValue('0');
        this.storicheYes = false;
        this.isDiagnosiDateCheckedStoriche = false;
        this.isAltraDataCheckedStoriche = false;
        this.storicheEIMSValue.value = '0';
        this.storicheEIMSValue.date = null;
      } else {
        this.statForm.get('storicheEIMS').setValue('1');
        this.storicheYes = true;
        this.storicheEIMSValue.value = '1';
        if (this.storicheEIMSValue.date === '' || this.storicheEIMSValue.date === null) {
          this.isDiagnosiDateCheckedStoriche = true;
          this.storicheEIMSValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      }
    }
  }

  selectAttiveEIMS($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('attiveEIMS').setValue('1');
        this.attiveYes = true;
        this.attiveEIMSValue.value = '1';
        if (this.attiveEIMSValue.date === null || this.attiveEIMSValue.date === '') {
          this.isDiagnosiDateCheckedAttive = true;
          this.attiveEIMSValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('attiveEIMS').setValue('0');
        this.attiveYes = false;
        this.isDiagnosiDateCheckedAttive = false;
        this.isAltraDataCheckedAttive = false;
        this.attiveEIMSValue.value = '0';
        this.attiveEIMSValue.date = null;
      }
    }
  }

  selectInterventi($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('interventi').setValue('1');
      } else {
        this.statForm.get('interventi').setValue('0');
      }
    }
  }

  selectStomia($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('stomia').setValue('1');
        this.stomiaYes = true;
        this.stomiaValue.value = '1';
        if (this.stomiaValue.date === '' || this.stomiaValue.date === null) {
          this.isDiagnosiDateCheckedStomia = true;
          this.stomiaValue.date = this.statForm.value.dateOfDiagnosis + ' ' +
            '00' + ':' + '00' + ':' + '00';
        }
      } else {
        this.statForm.get('stomia').setValue('0');
        this.stomiaYes = false;
        this.isDiagnosiDateCheckedStomia = false;
        this.isAltraDataCheckedStomia = false;
        this.stomiaValue.value = '0';
        this.stomiaValue.date = null;
      }
    }
  }

  comparing(n1: string, n2: string) {
    const first = n1.split(' ');
    const second = n2.split(' ');
    // @ts-ignore
    const d1 = moment(first[0] + ' ' + first[1], 'DD/MM/YYYY h:mm:ss').toDate().getTime();
    // @ts-ignore
    const d2 = moment(second[0] + ' ' + second[1], 'DD/MM/YYYY h:mm:ss').toDate().getTime();
    return d1 < d2 ? 1 : (d1 > d2 ? -1 : 0);
  }

  calcDate(): string {
    const date = new Date();
    return date.getDate() + '/' +
      (date.getMonth() + 1) + '/' +
      date.getFullYear() + ' ' +
      date.getHours() + ':' +
      date.getMinutes() + ':' +
      date.getSeconds();
  }

  calcDateWithoutHours(): string {
    const date = new Date();
    return date.getDate() + '/' +
      (date.getMonth() + 1) + '/' +
      date.getFullYear();
  }

  onSubmit(value: any) {
    this.editing = false;
    this.confirmValue = true;
    // questi controlli servono per creare i campi solo nel caso in cui si è nel primo inserimento
    // in cui si mantengono i valori di default
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.infiammatorioCD.length === 0 && this.isAltraDataCheckedInfiammatorio === false && this.isDiagnosiDateCheckedInfiammatorio === true) {
      if (this.isPatientCrohn === true) {
        const data = this.statForm.value.dateOfDiagnosis + ' ' +
          '00' + ':' + '00' + ':' + '00';
        this.createFieldInfiammatorio(this.statForm.value.infiammatorioCD, data);
      }
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.stenosanteCD.length === 0 && this.isAltraDataCheckedStenosante === false && this.isDiagnosiDateCheckedStenosante === true) {
      if (this.isPatientCrohn === true) {
        const data = this.statForm.value.dateOfDiagnosis + ' ' +
          '00' + ':' + '00' + ':' + '00';
        this.createFieldStenosante(this.statForm.value.stenosanteCD, data);
      }
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.penetranteCD.length === 0 && this.isAltraDataCheckedPenetrante === false && this.isDiagnosiDateCheckedPenetrante === true) {
      if (this.isPatientCrohn === true) {
        const data = this.statForm.value.dateOfDiagnosis + ' ' +
          '00' + ':' + '00' + ':' + '00';
        this.createFieldPenetrante(this.statForm.value.penetranteCD, data);
      }
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.malattiaPerianaleCD.length === 0 && this.isAltraDataCheckedMalPeri === false && this.isDiagnosiDateCheckedMalPeri === true) {
      if (this.isPatientCrohn === true) {
        const data = this.statForm.value.dateOfDiagnosis + ' ' +
          '00' + ':' + '00' + ':' + '00';
        this.createFieldMalPeri(this.statForm.value.malattiaPerianaleCD, data);
      }
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.locatColonCD.length === 0 && this.isAltraDataCheckedLocatColon === false && this.isDiagnosiDateCheckedLocatColon === true) {
      if (this.isPatientCrohn === true) {
        const data = this.statForm.value.dateOfDiagnosis + ' ' +
          '00' + ':' + '00' + ':' + '00';
        this.createFieldLocatColon(this.statForm.value.locatColonCD, data);
      }
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.locatIleumCD.length === 0 && this.isAltraDataCheckedLocatIleum === false && this.isDiagnosiDateCheckedLocatIleum === true) {
      if (this.isPatientCrohn === true) {
        const data = this.statForm.value.dateOfDiagnosis + ' ' +
          '00' + ':' + '00' + ':' + '00';
        this.createFieldLocatIleum(this.statForm.value.locatIleumCD, data);
      }
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.locatUpperGI.length === 0 && this.isAltraDataCheckedLocatUpper === false && this.isDiagnosiDateCheckedLocatUpper === true) {
      if (this.isPatientCrohn === true) {
        const data = this.statForm.value.dateOfDiagnosis + ' ' +
          '00' + ':' + '00' + ':' + '00';
        this.createFieldLocatUpper(this.statForm.value.locatUpperGI, data);
      }
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.localizzazioneUC.length === 0 && this.isAltraDataCheckedLocUC === false && this.isDiagnosiDateCheckedLocUC === true) {
      if (this.isPatientCrohn === false) {
        const data = this.statForm.value.dateOfDiagnosis + ' ' +
          '00' + ':' + '00' + ':' + '00';
        this.createFieldLocUC(this.statForm.value.localizzazioneUC, data);
      }
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.attiveEIMS.length === 0 && this.isAltraDataCheckedAttive === false && this.isDiagnosiDateCheckedAttive === true) {
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      this.createFieldAttive(this.statForm.value.attiveEIMS, data);
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.storicheEIMS.length === 0 && this.isAltraDataCheckedStoriche === false && this.isDiagnosiDateCheckedStoriche === true) {
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      this.createFieldStoriche(this.statForm.value.storicheEIMS, data);
    }
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.stomia.length === 0 && this.isAltraDataCheckedStomia === false && this.isDiagnosiDateCheckedStomia === true) {
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      this.createFieldStomia(this.statForm.value.stomia, data);
    }
    // note
    const notes = this.patientBodyStat.bodyStat.notes;
    console.log(notes);
    // inizializzazione di tutte le variabili cliniche dinamiche
    // inserimento dei valori nelle liste
    const therapies = this.patientBodyStat.bodyStat.therapies;
    const therapy = new Therapy('', '');
    // i seguenti servono per inserire la data di input del valore
    const infiammatorioCD = this.patientBodyStat.bodyStat.infiammatorioCD;
    if (this.isPatientCrohn === true) {
      this.infiammatorioCDValue.dateInput = this.calcDate();
      infiammatorioCD.push(this.infiammatorioCDValue);
    }
    const stenosanteCD = this.patientBodyStat.bodyStat.stenosanteCD;
    if (this.isPatientCrohn === true) {
      this.stenosanteCDValue.dateInput = this.calcDate();
      stenosanteCD.push(this.stenosanteCDValue);
    }
    const penetranteCD = this.patientBodyStat.bodyStat.penetranteCD;
    if (this.isPatientCrohn === true) {
      this.penetranteCDValue.dateInput = this.calcDate();
      penetranteCD.push(this.penetranteCDValue);
    }
    const malattiaPerianaleCD = this.patientBodyStat.bodyStat.malattiaPerianaleCD;
    if (this.isPatientCrohn === true) {
      this.malattiaPerianaleCDValue.dateInput = this.calcDate();
      malattiaPerianaleCD.push(this.malattiaPerianaleCDValue);
    }
    const locatColonCD = this.patientBodyStat.bodyStat.locatColonCD;
    if (this.isPatientCrohn === true) {
      this.locatColonCDValue.dateInput = this.calcDate();
      locatColonCD.push(this.locatColonCDValue);
    }
    const locatIleumCD = this.patientBodyStat.bodyStat.locatIleumCD;
    if (this.isPatientCrohn === true) {
      this.locatIleumCDValue.dateInput = this.calcDate();
      locatIleumCD.push(this.locatIleumCDValue);
    }
    const locatUpperGI = this.patientBodyStat.bodyStat.locatUpperGI;
    if (this.isPatientCrohn === true) {
      this.locatUpperGIValue.dateInput = this.calcDate();
      locatUpperGI.push(this.locatUpperGIValue);
    }
    // per UC e IBD_U
    const localizzazioneUC = this.patientBodyStat.bodyStat.localizzazioneUC;
    if (this.isPatientUC === true) {
      this.localizzazioneUCValue.dateInput = this.calcDate();
      localizzazioneUC.push(this.localizzazioneUCValue);
    }
    // per tutti
    const storicheEIMS = this.patientBodyStat.bodyStat.storicheEIMS;
    this.storicheEIMSValue.dateInput = this.calcDate();
    storicheEIMS.push(this.storicheEIMSValue);
    const attiveEIMS = this.patientBodyStat.bodyStat.attiveEIMS;
    this.attiveEIMSValue.dateInput = this.calcDate();
    attiveEIMS.push(this.attiveEIMSValue);
    const stomia = this.patientBodyStat.bodyStat.stomia;
    this.stomiaValue.dateInput = this.calcDate();
    stomia.push(this.stomiaValue);
    // terapia: inizializzazione delle variabili
    const therapy5ASAOS = this.patientBodyStat.bodyStat.therapy5ASAOS;
    const therapyTOPICA = this.patientBodyStat.bodyStat.therapyTOPICA;
    const therapyGCSOS = this.patientBodyStat.bodyStat.therapyGCSOS;
    const therapyIMM = this.patientBodyStat.bodyStat.therapyIMM;
    const therapyBIO = this.patientBodyStat.bodyStat.therapyBIO;
    // aggiungo la nota
    if (value.notes !== null && value.notes !== undefined && value.notes.localeCompare('') !== 0) {
      console.log(notes);
      notes.push(this.calcDate() + ' - ' + value.notes);
    }
    if (value.therapies !== null && value.therapies !== undefined && value.therapies.localeCompare('') !== 0) {
      therapy.date = this.calcDate();
      therapy.therapy = value.therapies;
      therapies.push(therapy);
    }
    if (value.therapy5ASAOS !== null && value.therapy5ASAOS !== undefined) {
      this.fiveASAOSValue.dateInput = this.calcDate();
      therapy5ASAOS.push(this.fiveASAOSValue);
    }
    if (value.therapyTOPICA !== null && value.therapyTOPICA !== undefined) {
      this.topicaValue.dateInput = this.calcDate();
      therapyTOPICA.push(this.topicaValue);
    }
    if (value.therapyGCSOS !== null && value.therapyGCSOS !== undefined) {
      this.gcsOSValue.dateInput = this.calcDate();
      therapyGCSOS.push(this.gcsOSValue);
    }
    if (value.therapyIMM !== null && value.therapyIMM !== undefined) {
      this.immValue.dateInput = this.calcDate();
      therapyIMM.push(this.immValue);
    }
    if (value.therapyBIO !== null && value.therapyBIO !== undefined) {
      this.bioValue.dateInput = this.calcDate();
      therapyBIO.push(this.bioValue);
    }
    /*// creazione della statForm che verrà inviata al BE
    const statForm = new StatForm(value.weight, value.height, value.age,
        value.sex, value.dateOfDiagnosis, value.ageOfDiagnosis,
        value.familiarity, value.pathologyDuration, value.pathology,
        notes, therapies, infiammatorioCD, stenosanteCD, penetranteCD,
        malattiaPerianaleCD, locatColonCD, locatIleumCD,
        locatUpperGI, localizzazioneUC, storicheEIMS,
        attiveEIMS, value.interventi, value.numResezioni,
        stomia, therapy5ASAOS, therapyTOPICA, therapyGCSOS, therapyIMM, therapyBIO);*/
    // creazione della statForm che verrà inviata al BE
    this.formToSend = new StatForm(value.weight, value.height, value.age,
      value.sex, value.dateOfDiagnosis, value.ageOfDiagnosis,
      value.familiarity, value.pathologyDuration, value.pathology,
      notes, therapies, infiammatorioCD, stenosanteCD, penetranteCD,
      malattiaPerianaleCD, locatColonCD, locatIleumCD,
      locatUpperGI, localizzazioneUC, storicheEIMS,
      attiveEIMS, value.interventi, value.numResezioni,
      stomia, therapy5ASAOS, therapyTOPICA, therapyGCSOS, therapyIMM, therapyBIO);
    // console.log(statForm);
    console.log(this.formToSend);
    this.openConfirmDialog();
  }

  sendData() {
    this.doctorService.editPatientClinicalProfile(this.patient.ssn, this.formToSend).subscribe(res => {
      if (res.status === 200) {
        // RESTA DA MODIFICARE QUI E TUTTE LE FUNZIONI SELECT
        this.showButton = true;
        this.openSnackBar('Informazioni modificate con successo!', 'Chiudi');
        this.showSpinner = false;
        let patients: Patient[] = JSON.parse(localStorage.getItem('patients'));
        patients = patients.slice().filter(p => p.ssn.localeCompare(this.patientSSN) !== 0);
        // @ts-ignore
        this.patientBodyStat.bodyStat = res.body;
        patients.push(this.patient);
        localStorage.setItem('patients', JSON.stringify(patients));
        this.statForm.get('notes').reset();
        this.statForm.get('therapies').reset();
        this.statForm.get('penetranteCD').reset();
        this.statForm.get('stenosanteCD').reset();
        this.statForm.get('penetranteCD').reset();
        this.statForm.get('malattiaPerianaleCD').reset();
        this.statForm.get('locatColonCD').reset();
        this.statForm.get('locatIleumCD').reset();
        this.statForm.get('locatUpperGI').reset();
        this.statForm.get('localizzazioneUC').reset();
        this.statForm.get('storicheEIMS').reset();
        this.statForm.get('attiveEIMS').reset();
        this.statForm.get('stomia').reset();
        this.statForm.get('therapy5ASAOS').reset();
        this.statForm.get('therapyGCSOS').reset();
        this.statForm.get('therapyTOPICA').reset();
        this.statForm.get('therapyIMM').reset();
        this.statForm.get('therapyBIO').reset();
        this.patientBodyStat.bodyStat.notes = this.patientBodyStat.bodyStat.notes.slice().sort((n1, n2) => this.comparing(n1, n2));
        // riordinamento delle variabili per la visualizzazione immediatamente dopo aver inserito una nuova form
        if (this.patientBodyStat.bodyStat.therapies === null) {
          this.patientBodyStat.bodyStat.therapies = [];
        } else {
          this.patientBodyStat.bodyStat.therapies = this.patientBodyStat.bodyStat.therapies.slice().sort((n1, n2) => this.comparing(n1.date, n2.date));
        }
        if (this.patientBodyStat.bodyStat.infiammatorioCD === null) {
          this.patientBodyStat.bodyStat.infiammatorioCD = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.infiammatorioCD = this.patientBodyStat.bodyStat.infiammatorioCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.stenosanteCD === null) {
          this.patientBodyStat.bodyStat.stenosanteCD = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.stenosanteCD = this.patientBodyStat.bodyStat.stenosanteCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.penetranteCD === null) {
          this.patientBodyStat.bodyStat.penetranteCD = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.penetranteCD = this.patientBodyStat.bodyStat.penetranteCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.malattiaPerianaleCD === null) {
          this.patientBodyStat.bodyStat.malattiaPerianaleCD = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.malattiaPerianaleCD = this.patientBodyStat.bodyStat.malattiaPerianaleCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.locatColonCD === null) {
          this.patientBodyStat.bodyStat.locatColonCD = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.locatColonCD = this.patientBodyStat.bodyStat.locatColonCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.locatIleumCD === null) {
          this.patientBodyStat.bodyStat.locatIleumCD = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.locatIleumCD = this.patientBodyStat.bodyStat.locatIleumCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.locatUpperGI === null) {
          this.patientBodyStat.bodyStat.locatUpperGI = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.locatUpperGI = this.patientBodyStat.bodyStat.locatUpperGI.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.localizzazioneUC === null) {
          this.patientBodyStat.bodyStat.localizzazioneUC = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.localizzazioneUC = this.patientBodyStat.bodyStat.localizzazioneUC.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.storicheEIMS === null) {
          this.patientBodyStat.bodyStat.storicheEIMS = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.storicheEIMS = this.patientBodyStat.bodyStat.storicheEIMS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.attiveEIMS === null) {
          this.patientBodyStat.bodyStat.attiveEIMS = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.attiveEIMS = this.patientBodyStat.bodyStat.attiveEIMS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.stomia === null) {
          this.patientBodyStat.bodyStat.stomia = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.stomia = this.patientBodyStat.bodyStat.stomia.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.therapy5ASAOS === null) {
          this.patientBodyStat.bodyStat.therapy5ASAOS = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.therapy5ASAOS = this.patientBodyStat.bodyStat.therapy5ASAOS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.therapyTOPICA === null) {
          this.patientBodyStat.bodyStat.therapyTOPICA = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.therapyTOPICA = this.patientBodyStat.bodyStat.therapyTOPICA.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.therapyGCSOS === null) {
          this.patientBodyStat.bodyStat.therapyGCSOS = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.therapyGCSOS = this.patientBodyStat.bodyStat.therapyGCSOS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.therapyIMM === null) {
          this.patientBodyStat.bodyStat.therapyIMM = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.therapyIMM = this.patientBodyStat.bodyStat.therapyIMM.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }

        if (this.patientBodyStat.bodyStat.therapyBIO === null) {
          this.patientBodyStat.bodyStat.therapyBIO = [];
        } else {
          // tslint:disable-next-line:max-line-length
          this.patientBodyStat.bodyStat.therapyBIO = this.patientBodyStat.bodyStat.therapyBIO.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
        }
      }
    },
      error => {
        console.log(error);
        this.showSpinner = false;
        this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
        this.delay(200).then(anything => {
          window.location.reload();
        });
        // if (error.status === 500) {
        //   localStorage.setItem('expirationTime', '0');
        //   console.log('SESSIONE SCADUTA');
        //   location.reload();
        // }
      });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(res => {
      console.log('Finestra chiusa');
    });
  }

  modify_birthDate() {
    this.editing_birthDate = true;
  }
  // è la funzione che si esegue come si vogliono aggiungere dati clinici
  modify() {
    // si setta in automatico l'età esatta
    this.riempiFormModify();
    this.editing = true;
    // controllo subito le date degli ultimi valori inseriti per impostare a true o false le variabili
    // che fanno apparire selezionata o meno 'datat diagnosi' o 'altra data' e fanno sì che
    // la form risulti essere già precompilata
    if (this.isPatientCrohn === true) {
      this.checkDataInfiammatorio();
      this.checkDataStenosante();
      this.checkDataPenetrante();
      this.checkDataMalPeri();
      this.checkDataLocatColon();
      this.checkDataLocatIleum();
      this.checkDataLocatUpperGI();
    } else {
      this.checkDataLocalizzazioneUC();
    }
    this.checkDataStoriche();
    this.checkDataAttive();
    this.checkDataStomia();
    this.checkData5ASAOS();
    this.checkDataGCSOS();
    this.checkDataTOPICA();
    this.checkDataBIO();
    this.checkDataIMM();
  }

  riempiFormModify() {
    this.statForm.get('height').setValue(this.patientBodyStat.bodyStat.height + " cm");
    this.statForm.get('age').setValue(this.patientBodyStat.bodyStat.age);
    this.statForm.get('ageOfDiagnosis').setValue(this.patientBodyStat.bodyStat.ageOfDiagnosis);
    this.statForm.get('pathologyDuration').setValue(this.patientBodyStat.bodyStat.ageOfDiagnosis);
    this.statForm.get('weight').setValue(this.patientBodyStat.bodyStat.weight + " kg");
  }

  // per eliminare una nota inserita in passato
  deleteNote(n: string) {
    this.doctorService.deleteNote(this.patient.email, n).subscribe(res => {
      if (res.status === 200) {
        this.openSnackBar('Nota eliminata con successo!', 'Chiudi');
        let patients: Patient[] = JSON.parse(localStorage.getItem('patients'));
        patients = patients.slice().filter(p => p.ssn.localeCompare(this.patientSSN) !== 0);
        this.patientBodyStat.bodyStat.notes = this.patientBodyStat.bodyStat.notes.slice().filter(note => note.localeCompare(n) !== 0);
        patients.push(this.patient);
        localStorage.setItem('patients', JSON.stringify(patients));
      }
    },
      error => {
        this.openErrorDialog('Si è verificato un errore. Le modifiche non verranno salvate.');
        console.log(error);
      });
  }

  // per eliminare una terapia inserita in passato
  deleteTherapy(n: Therapy) {
    this.doctorService.deleteTherapy(this.patient.email, n).subscribe(res => {
      if (res.status === 200) {
        this.openSnackBar('Terapia eliminata con successo!', 'Chiudi');
        let patients: Patient[] = JSON.parse(localStorage.getItem('patients'));
        patients = patients.slice().filter(p => p.ssn.localeCompare(this.patientSSN) !== 0);
        // tslint:disable-next-line:max-line-length
        this.patientBodyStat.bodyStat.therapies = this.patientBodyStat.bodyStat.therapies.slice().filter(terapie => terapie.date.localeCompare(n.date) !== 0);
        patients.push(this.patient);
        localStorage.setItem('patients', JSON.stringify(patients));
      }
    },
      error => {
        this.openErrorDialog('Si è verificato un errore. Le modifiche non verranno salvate.');
        console.log(error);
      });
  }

  // il setDate serve per settare la data della diagnosi e di conseguenza anche l'età della diagnosi e la durata della patologia
  setDate($event: MatDatepickerInputEvent<any>) {
    const value =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10);
    this.statForm.get('dateOfDiagnosis').setValue(value);
    const birthdate = this.patient.birthDate.split("-")[2] + "/" + this.patient.birthDate.split("-")[1] + "/" + this.patient.birthDate.split("-")[0];
    console.log(birthdate);
    console.log(value)
    this.statForm.get('ageOfDiagnosis').setValue(this.getYearsOfDifference(birthdate, value));
    this.statForm.get('pathologyDuration').setValue(this.getYearsOfDifference(value, this.calcDateWithoutHours()));
    // se cambio la data della diagnosi devo cambiare anche i campi settati alla data della diagnosi
    // per tutti
    if (this.isDiagnosiDateCheckedAttive === true) {
      this.attiveEIMSValue.date = value + ' 00:00:00';
    }
    if (this.isDiagnosiDateCheckedStoriche === true) {
      this.storicheEIMSValue.date = value + ' 00:00:00';
    }
    if (this.isDiagnosiDateCheckedStomia === true) {
      this.stomiaValue.date = value + ' 00:00:00';
    }
    // diferenzio crohn dagli altri
    if (this.isPatientCrohn === true) {
      if (this.isDiagnosiDateCheckedInfiammatorio === true) {
        this.infiammatorioCDValue.date = value + ' 00:00:00';
      }
      if (this.isDiagnosiDateCheckedStenosante === true) {
        this.stenosanteCDValue.date = value + ' 00:00:00';
      }
      if (this.isDiagnosiDateCheckedPenetrante === true) {
        this.penetranteCDValue.date = value + ' 00:00:00';
      }
      if (this.isDiagnosiDateCheckedMalPeri === true) {
        this.malattiaPerianaleCDValue.date = value + ' 00:00:00';
      }
      if (this.isDiagnosiDateCheckedLocatColon === true) {
        this.locatColonCDValue.date = value + ' 00:00:00';
      }
      if (this.isDiagnosiDateCheckedLocatIleum === true) {
        this.locatIleumCDValue.date = value + ' 00:00:00';
      }
      if (this.isDiagnosiDateCheckedLocatUpper === true) {
        this.locatUpperGIValue.date = value + ' 00:00:00';
      }
    } else {
      if (this.isDiagnosiDateCheckedLocUC === true) {
        this.localizzazioneUCValue.date = value + ' 00:00:00';
      }
    }
  }

  setBirthDate($event: MatDatepickerInputEvent<any>) {
    const value =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10);
    this.newBirthDate = value;
  }

  closeSetNewBirthDate() {
    this.editing_birthDate = false;
  }
  setNewBirthDate() {
    console.log(this.newBirthDate);
    this.doctorService.setNewBirthdate(this.newBirthDate, this.patient.email).subscribe(data => {
      console.log(data);
      if (data == 'true') {
        this.editing_birthDate = false;
        this.openSnackBar('Data di nascita modificata!', 'Chiudi');
        //reinizializzo i dati
        this.doctorService.getPatient(this.patientSSN).subscribe(data => {
          data.birthDate = data.birthDate.split("-")[2] + "/" + data.birthDate.split("-")[1] + "/" + data.birthDate.split("-")[0];
          this.patient = data;
          console.log(this.patient);
        });
        this.doctorService.getBodyStatPatient(this.patientSSN).subscribe((patientBodyStat) => {
          this.patientBodyStat = patientBodyStat;
          console.log(this.patientBodyStat);
          this.initialization();
        }
          , error => {
            console.log('ERROR LOADING BOADY STAT');
            location.reload();
          });
      }
      else {
        this.openErrorDialog('Si è verificato un errore. Le modifiche non verranno salvate.');
      }


    }, error => {
      this.openErrorDialog('Si è verificato un errore. Le modifiche non verranno salvate.');
      location.reload();
    });

  }

  // calcola la differenza tra due date in termini di anni
  getYearsOfDifference(n1: string, n2: string) {
    // @ts-ignore
    const d1 = moment(n1, 'DD/MM/YYYY h:mm:ss').toDate().getFullYear();
    // @ts-ignore
    const d2 = moment(n2, 'DD/MM/YYYY h:mm:ss').toDate().getFullYear();
    return d2 - d1;
  }

  // per convertire l'output
  convertValue(value: string): string {
    let variable = '';
    if (value === '0') {
      variable = 'no';
    } else {
      variable = 'si';
    }
    return variable;
  }

  // per convertire l'output
  convertValueLocalizzazioneUC(value: string): string {
    let variable = '';
    if (value === '1') {
      variable = 'Proctite';
    } else if (value === '2') {
      variable = 'Colite sinistra';
    } else {
      variable = 'Pancolite';
    }
    return variable;
  }

  // per convertire l'output sex
  convertValueSex(value: string): string {
    let variable = '';
    if (value === '1') {
      variable = 'Donna';
    } else if (value === '2') {
      variable = 'Uomo';
    } else {
      variable = 'Altro';
    }
    return variable;
  }

  // per convertire l'output
  convertValueStoriche(value: string): string {
    let variable = '';
    if (value === '0') {
      variable = 'no';
    } else {
      variable = 'si, qualsiasi numero';
    }
    return variable;
  }

  getLastValue(array: ClinicalData[]) {
    // @ts-ignore
    const now = moment(new Date(), 'DD/MM/YYYY h:mm:ss').toDate();
    const diff = 0;
    let nearest = '';
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < array.length; i++) {
      // @ts-ignore
      const data = moment(array[i].date, 'DD/MM/YYYY h:mm:ss').toDate();
      if (i === 0) {
        nearest = array[i].date;
      } else if ((now - data) < diff) {
        nearest = array[i].date;
      }
    }
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < array.length; i++) {
      if (array[i].date === nearest) {
        console.log(array[i].value);
        return array[i].value;
      }
    }
  }

  // questa funzione serve per l'apertura del dialog con il grafico sulle terapie
  openDialog(array: Therapy2[], title: string, therapies: Therapy[], notes: string[]) {
    this.dialog.open(InfoClinicalDialogComponent, {
      width: '1050px',
      height: '650px',
      data: {
        dataKey: array,
        dataTitle: title,
        dataTherapies: therapies,
        dataNotes: notes
      }
    });
  }

  // **********************************************************************************************//
  // queste funzioni si richiamano quando l'utente va a modificare e ad inserire un determinato input
  // modificando quelli che sono i valori di default
  // **** INFIAMMATORIO CD ***
  selectDateOfDiagnosisInfiammatorio(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedInfiammatorio = false;
      this.isDiagnosiDateCheckedInfiammatorio = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.infiammatorioCD;
      this.createFieldInfiammatorio(value, data);
    }
  }

  selectOtherDateInfiammatorio(event: MatCheckboxChange): void {
    this.isAltraDataCheckedInfiammatorio = false;
    if (event.checked === true) {
      this.isAltraDataCheckedInfiammatorio = true;
      this.isDiagnosiDateCheckedInfiammatorio = false;
    } else {
      this.isAltraDataCheckedInfiammatorio = false;
    }
  }

  selectDatePickerInfiammatorio($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedInfiammatorio = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.infiammatorioCD;
    this.createFieldInfiammatorio(value, data);
  }

  createFieldInfiammatorio(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.infiammatorioCD !== null && value.infiammatorioCD !== undefined) {
      this.infiammatorioCDValue.date = date;
      this.infiammatorioCDValue.value = valore;
    }
  }

  // **** STENOSANTE ***
  selectDateOfDiagnosisStenosante(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedStenosante = false;
      this.isDiagnosiDateCheckedStenosante = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.stenosanteCD;
      this.createFieldStenosante(value, data);
    }
  }

  selectOtherDateStenosante(event: MatCheckboxChange): void {
    this.isAltraDataCheckedStenosante = false;
    if (event.checked === true) {
      this.isAltraDataCheckedStenosante = true;
      this.isDiagnosiDateCheckedStenosante = false;
    } else {
      this.isAltraDataCheckedStenosante = false;
    }
  }

  selectDatePickerStenosante($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedStenosante = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.stenosanteCD;
    this.createFieldStenosante(value, data);
  }

  createFieldStenosante(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.stenosanteCD !== null && value.stenosanteCD !== undefined) {
      this.stenosanteCDValue.date = date;
      this.stenosanteCDValue.value = valore;
    }
  }

  // **** PENETRANTE ***
  selectDateOfDiagnosisPenetrante(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedPenetrante = false;
      this.isDiagnosiDateCheckedPenetrante = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.penetranteCD;
      this.createFieldPenetrante(value, data);
    }
  }

  selectOtherDatePenetrante(event: MatCheckboxChange): void {
    this.isAltraDataCheckedPenetrante = false;
    if (event.checked === true) {
      this.isAltraDataCheckedPenetrante = true;
      this.isDiagnosiDateCheckedPenetrante = false;
    } else {
      this.isAltraDataCheckedPenetrante = false;
    }
  }

  selectDatePickerPenetrante($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedPenetrante = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.penetranteCD;
    this.createFieldPenetrante(value, data);
  }

  createFieldPenetrante(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.penetranteCD !== null && value.penetranteCD !== undefined) {
      this.penetranteCDValue.date = date;
      this.penetranteCDValue.value = valore;
    }
  }

  // **** MALATTIA PERIANALE
  selectDateOfDiagnosisMalPeri(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedMalPeri = false;
      this.isDiagnosiDateCheckedMalPeri = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.malattiaPerianaleCD;
      this.createFieldMalPeri(value, data);
    }
  }

  selectOtherDateMalPeri(event: MatCheckboxChange): void {
    this.isAltraDataCheckedMalPeri = false;
    if (event.checked === true) {
      this.isAltraDataCheckedMalPeri = true;
      this.isDiagnosiDateCheckedMalPeri = false;
    } else {
      this.isAltraDataCheckedMalPeri = false;
    }
  }

  selectDatePickerMalPeri($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedMalPeri = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.malattiaPerianaleCD;
    this.createFieldMalPeri(value, data);
  }

  createFieldMalPeri(valore: string, date: string) {
    const value = this.statForm.value;
    // tslint:disable-next-line:max-line-length
    if (value.malattiaPerianaleCD !== null && value.malattiaPerianaleCD !== undefined) {
      this.malattiaPerianaleCDValue.date = date;
      this.malattiaPerianaleCDValue.value = valore;
    }
  }

  // **** LOCAT COLON ***
  selectDateOfDiagnosisLocatColon(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedLocatColon = false;
      this.isDiagnosiDateCheckedLocatColon = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.locatColonCD;
      this.createFieldLocatColon(value, data);
    }
  }

  selectOtherDateLocatColon(event: MatCheckboxChange): void {
    this.isAltraDataCheckedLocatColon = false;
    if (event.checked === true) {
      this.isAltraDataCheckedLocatColon = true;
      this.isDiagnosiDateCheckedLocatColon = false;
    } else {
      this.isAltraDataCheckedLocatColon = false;
    }
  }

  selectDatePickerLocatColon($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedLocatColon = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.locatColonCD;
    this.createFieldLocatColon(value, data);
  }

  createFieldLocatColon(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.locatColonCD !== null && value.locatColonCD !== undefined) {
      this.locatColonCDValue.date = date;
      this.locatColonCDValue.value = valore;
    }
  }

  // **** LOCAT ILEUM ***
  selectDateOfDiagnosisLocatIleum(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedLocatIleum = false;
      this.isDiagnosiDateCheckedLocatIleum = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.locatIleumCD;
      this.createFieldLocatIleum(value, data);
    }
  }

  selectOtherDateLocatIleum(event: MatCheckboxChange): void {
    this.isAltraDataCheckedLocatIleum = false;
    if (event.checked === true) {
      this.isAltraDataCheckedLocatIleum = true;
      this.isDiagnosiDateCheckedLocatIleum = false;
    } else {
      this.isAltraDataCheckedLocatIleum = false;
    }
  }

  selectDatePickerLocatIleum($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedLocatIleum = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.locatIleumCD;
    this.createFieldLocatIleum(value, data);
  }

  createFieldLocatIleum(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.locatIleumCD !== null && value.locatIleumCD !== undefined) {
      this.locatIleumCDValue.date = date;
      this.locatIleumCDValue.value = valore;
    }
  }

  // **** LOCAT UPPER GI ***
  selectDateOfDiagnosisLocatUpper(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedLocatUpper = false;
      this.isDiagnosiDateCheckedLocatUpper = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.locatUpperGI;
      this.createFieldLocatUpper(value, data);
    }
  }

  selectOtherDateLocatUpper(event: MatCheckboxChange): void {
    this.isAltraDataCheckedLocatUpper = false;
    if (event.checked === true) {
      this.isAltraDataCheckedLocatUpper = true;
      this.isDiagnosiDateCheckedLocatUpper = false;
    } else {
      this.isAltraDataCheckedLocatUpper = false;
    }
  }

  selectDatePickerLocatUpper($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedLocatUpper = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.locatUpperGI;
    this.createFieldLocatUpper(value, data);
  }

  createFieldLocatUpper(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.locatUpperGI !== null && value.locatUpperGI !== undefined) {
      this.locatUpperGIValue.date = date;
      this.locatUpperGIValue.value = valore;
    }
  }

  // **** LOCAT UC ***
  selectDateOfDiagnosisLocUC(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedLocUC = false;
      this.isDiagnosiDateCheckedLocUC = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.localizzazioneUC;
      this.createFieldLocUC(value, data);
    }
  }

  selectOtherDateLocUC(event: MatCheckboxChange): void {
    this.isAltraDataCheckedLocUC = false;
    if (event.checked === true) {
      this.isAltraDataCheckedLocUC = true;
      this.isDiagnosiDateCheckedLocUC = false;
    } else {
      this.isAltraDataCheckedLocUC = false;
    }
  }

  selectDatePickerLocUC($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedLocUC = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.localizzazioneUC;
    this.createFieldLocUC(value, data);
  }

  createFieldLocUC(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.localizzazioneUC !== null && value.localizzazioneUC !== undefined) {
      this.localizzazioneUCValue.date = date;
      this.localizzazioneUCValue.value = valore;
    }
  }

  // **** STORICHE ***
  selectDateOfDiagnosisStoriche(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedStoriche = false;
      this.isDiagnosiDateCheckedStoriche = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.storicheEIMS;
      this.createFieldStoriche(value, data);
    }
  }

  selectOtherDateStoriche(event: MatCheckboxChange): void {
    this.isAltraDataCheckedStoriche = false;
    if (event.checked === true) {
      this.isAltraDataCheckedStoriche = true;
      this.isDiagnosiDateCheckedStoriche = false;
    } else {
      this.isAltraDataCheckedStoriche = false;
    }
  }

  selectDatePickerStoriche($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedStoriche = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.storicheEIMS;
    this.createFieldStoriche(value, data);
  }

  createFieldStoriche(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.storicheEIMS !== null && value.storicheEIMS !== undefined) {
      this.storicheEIMSValue.date = date;
      this.storicheEIMSValue.value = valore;
    }
  }

  // **** ATTIVE ***
  selectDateOfDiagnosisAttive(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedAttive = false;
      this.isDiagnosiDateCheckedAttive = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.attiveEIMS;
      this.createFieldAttive(value, data);
    }
  }

  selectOtherDateAttive(event: MatCheckboxChange): void {
    this.isAltraDataCheckedAttive = false;
    if (event.checked === true) {
      this.isAltraDataCheckedAttive = true;
      this.isDiagnosiDateCheckedAttive = false;
    } else {
      this.isAltraDataCheckedAttive = false;
    }
  }

  selectDatePickerAttive($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedAttive = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.attiveEIMS;
    this.createFieldAttive(value, data);
  }

  createFieldAttive(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.attiveEIMS !== null && value.attiveEIMS !== undefined) {
      this.attiveEIMSValue.date = date;
      this.attiveEIMSValue.value = valore;
    }
  }

  // **** STOMIA ***
  selectDateOfDiagnosisStomia(event: MatCheckboxChange): void {
    if (event.checked === true) {
      this.isAltraDataCheckedStomia = false;
      this.isDiagnosiDateCheckedStomia = true;
      const data = this.statForm.value.dateOfDiagnosis + ' ' +
        '00' + ':' + '00' + ':' + '00';
      const value = this.statForm.value.stomia;
      this.createFieldStomia(value, data);
    }
  }

  selectOtherDateStomia(event: MatCheckboxChange): void {
    this.isAltraDataCheckedStomia = false;
    if (event.checked === true) {
      this.isAltraDataCheckedStomia = true;
      this.isDiagnosiDateCheckedStomia = false;
    } else {
      this.isAltraDataCheckedStomia = false;
    }
  }

  selectDatePickerStomia($event: MatDatepickerInputEvent<any>) {
    this.isAltraDataCheckedStomia = true;
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    const value = this.statForm.value.stomia;
    this.createFieldStomia(value, data);
  }

  createFieldStomia(valore: string, date: string) {
    const value = this.statForm.value;
    if (value.stomia !== null && value.stomia !== undefined) {
      this.stomiaValue.date = date;
      this.stomiaValue.value = valore;
    }
  }

  // sezione sulle terapie
  // se la terapia si è mai fatta appre il campo per sapere se la terapia è in corso
  // e se è in corso appare il campo per inserire la data di inizio della terapia
  // 5asaos: in base alle selezioni si inseriscono i dati
  selectFiveASAOSpast($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('therapy5ASAOS').setValue('1');
        this.fiveASAOSpast = true;
        this.fiveASAOSValue.done = '1';
      } else {
        this.statForm.get('therapy5ASAOS').setValue('0');
        this.fiveASAOSpast = false;
        this.fiveASAOSpresent = false;
        this.fiveASAOSValue.done = '0';
        this.fiveASAOSValue.onGoing = null;
        this.fiveASAOSValue.dateOfStart = null;
      }
    }
  }

  selectFiveASAOSpresent($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.fiveASAOSpresent = true;
        this.fiveASAOSValue.onGoing = '1';
        this.fiveASAOSValue.dateOfStart = this.lastDateOfStart5ASA + ' ' +
          '00' + ':' + '00' + ':' + '00';
      } else {
        this.fiveASAOSpresent = false;
        this.fiveASAOSValue.onGoing = '0';
        this.fiveASAOSValue.dateOfStart = null;
      }
    }
  }

  selectDate5ASA($event: MatDatepickerInputEvent<any>) {
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    this.fiveASAOSValue.dateOfStart = data;
  }

  // gcs os: in base alle selezioni si inseriscono i dati
  selectGCSpast($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('therapyGCSOS').setValue('1');
        this.gcsPast = true;
        this.gcsOSValue.done = '1';
      } else {
        this.statForm.get('therapyGCSOS').setValue('0');
        this.gcsPast = false;
        this.gcsPresent = false;
        this.gcsOSValue.done = '0';
        this.gcsOSValue.onGoing = null;
        this.gcsOSValue.dateOfStart = null;
      }
    }
  }

  selectGCSpresent($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.gcsPresent = true;
        this.gcsOSValue.onGoing = '1';
        this.gcsOSValue.dateOfStart = this.lastDateOfStartGCS + ' ' +
          '00' + ':' + '00' + ':' + '00';
      } else {
        this.gcsPresent = false;
        this.gcsOSValue.onGoing = '0';
        this.gcsOSValue.dateOfStart = null;
      }
    }
  }

  selectDateGCS($event: MatDatepickerInputEvent<any>) {
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    this.gcsOSValue.dateOfStart = data;
  }

  // topica: in base alle selezioni si inseriscono i dati
  selectTopicapast($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('therapyTOPICA').setValue('1');
        this.topicaPast = true;
        this.topicaValue.done = '1';
      } else {
        this.statForm.get('therapyTOPICA').setValue('0');
        this.topicaPast = false;
        this.topicaPresent = false;
        this.topicaValue.done = '0';
        this.topicaValue.onGoing = null;
        this.topicaValue.dateOfStart = null;
      }
    }
  }

  selectTopicapresent($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.topicaPresent = true;
        this.topicaValue.onGoing = '1';
        this.topicaValue.dateOfStart = this.lastDateOfStartTOPICA + ' ' +
          '00' + ':' + '00' + ':' + '00';
      } else {
        this.topicaPresent = false;
        this.topicaValue.onGoing = '0';
        this.topicaValue.dateOfStart = null;
      }
    }
  }

  selectDateTopica($event: MatDatepickerInputEvent<any>) {
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    this.topicaValue.dateOfStart = data;
  }

  // immuno: in base alle selezioni si inseriscono i dati
  selectImmpast($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('therapyIMM').setValue('1');
        this.immPast = true;
        this.immValue.done = '1';
      } else {
        this.statForm.get('therapyIMM').setValue('0');
        this.immPast = false;
        this.immPresent = false;
        this.immValue.done = '0';
        this.immValue.onGoing = null;
        this.immValue.dateOfStart = null;
      }
    }
  }

  selectImmpresent($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.immPresent = true;
        this.immValue.onGoing = '1';
        this.immValue.dateOfStart = this.lastDateOfStartIMM + ' ' +
          '00' + ':' + '00' + ':' + '00';
      } else {
        this.immPresent = false;
        this.immValue.onGoing = '0';
        this.immValue.dateOfStart = null;
      }
    }
  }

  selectDateImm($event: MatDatepickerInputEvent<any>) {
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    this.immValue.dateOfStart = data;
  }

  // bio: in base alle selezioni si inseriscono i dati
  selectBiopast($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.statForm.get('therapyBIO').setValue('1');
        this.bioPast = true;
        this.bioValue.done = '1';
      } else {
        this.statForm.get('therapyBIO').setValue('0');
        this.bioPast = false;
        this.bioPresent = false;
        this.bioValue.done = '0';
        this.bioValue.onGoing = null;
        this.bioValue.dateOfStart = null;
      }
    }
  }

  selectBiopresent($event: MatOptionSelectionChange, value: string) {
    if ($event.isUserInput) {
      if (value === 'si') {
        this.bioPresent = true;
        this.bioValue.onGoing = '1';
        this.bioValue.dateOfStart = this.lastDateOfStartBIO + ' ' +
          '00' + ':' + '00' + ':' + '00';
      } else {
        this.bioPresent = false;
        this.bioValue.onGoing = '0';
        this.bioValue.dateOfStart = null;
      }
    }
  }

  selectDateBio($event: MatDatepickerInputEvent<any>) {
    const data =
      $event.target._dateAdapter.getDate($event.target.value).toString(10) + '/' +
      ($event.target._dateAdapter.getMonth($event.target.value) + 1).toString(10) + '/' +
      $event.target._dateAdapter.getYear($event.target.value).toString(10) + ' ' +
      '00' + ':' + '00' + ':' + '00';
    this.bioValue.dateOfStart = data;
  }

  // funzioni che servono per prendere i dati dell'ultimo valore inserito
  // queste vengono richiamate dalla funzione modify() che si esegue come
  // l'utente vuole modificare i dati
  checkDataInfiammatorio() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.infiammatorioCD !== undefined && this.patientBodyStat.bodyStat.infiammatorioCD !== null && this.patientBodyStat.bodyStat.infiammatorioCD.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.infiammatorioCD = this.patientBodyStat.bodyStat.infiammatorioCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.infiammatorioCD[0].date !== null) {
        if (this.patientBodyStat.bodyStat.infiammatorioCD[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedInfiammatorio = true;
          this.isAltraDataCheckedInfiammatorio = false;
        } else {
          this.isDiagnosiDateCheckedInfiammatorio = false;
          this.isAltraDataCheckedInfiammatorio = true;
          this.altraDataInf = this.patientBodyStat.bodyStat.infiammatorioCD[0].date.split(' ')[0];
        }
      } else {
        this.infiammatorioYes = false;
        this.isDiagnosiDateCheckedInfiammatorio = false;
        this.isAltraDataCheckedInfiammatorio = false;
      }
      this.createFieldInfiammatorio(this.patientBodyStat.bodyStat.infiammatorioCD[0].value, this.patientBodyStat.bodyStat.infiammatorioCD[0].date);
    }
  }

  checkDataStenosante() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.stenosanteCD !== undefined && this.patientBodyStat.bodyStat.stenosanteCD !== null && this.patientBodyStat.bodyStat.stenosanteCD.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.stenosanteCD = this.patientBodyStat.bodyStat.stenosanteCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.stenosanteCD[0].date !== null) {
        if (this.patientBodyStat.bodyStat.stenosanteCD[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedStenosante = true;
          this.isAltraDataCheckedStenosante = false;
        } else {
          this.isDiagnosiDateCheckedStenosante = false;
          this.isAltraDataCheckedStenosante = true;
          this.altraDataSte = this.patientBodyStat.bodyStat.stenosanteCD[0].date.split(' ')[0];
        }
      } else {
        this.stenosanteYes = false;
        this.isDiagnosiDateCheckedStenosante = false;
        this.isAltraDataCheckedStenosante = false;
      }
      this.createFieldStenosante(this.patientBodyStat.bodyStat.stenosanteCD[0].value, this.patientBodyStat.bodyStat.stenosanteCD[0].date);
    }
  }

  checkDataPenetrante() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.penetranteCD !== undefined && this.patientBodyStat.bodyStat.penetranteCD !== null && this.patientBodyStat.bodyStat.penetranteCD.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.penetranteCD = this.patientBodyStat.bodyStat.penetranteCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.penetranteCD[0].date !== null) {
        if (this.patientBodyStat.bodyStat.penetranteCD[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedPenetrante = true;
          this.isAltraDataCheckedPenetrante = false;
        } else {
          this.isDiagnosiDateCheckedPenetrante = false;
          this.isAltraDataCheckedPenetrante = true;
          this.altraDataPen = this.patientBodyStat.bodyStat.penetranteCD[0].date.split(' ')[0];
        }
      } else {
        this.penetranteYes = false;
        this.isDiagnosiDateCheckedPenetrante = false;
        this.isAltraDataCheckedPenetrante = false;
      }
      this.createFieldPenetrante(this.patientBodyStat.bodyStat.penetranteCD[0].value, this.patientBodyStat.bodyStat.penetranteCD[0].date);
    }
  }

  checkDataMalPeri() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.malattiaPerianaleCD !== undefined && this.patientBodyStat.bodyStat.malattiaPerianaleCD !== null && this.patientBodyStat.bodyStat.malattiaPerianaleCD.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.malattiaPerianaleCD = this.patientBodyStat.bodyStat.malattiaPerianaleCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.malattiaPerianaleCD[0].date !== null) {
        if (this.patientBodyStat.bodyStat.malattiaPerianaleCD[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedMalPeri = true;
          this.isAltraDataCheckedMalPeri = false;
        } else {
          this.isDiagnosiDateCheckedMalPeri = false;
          this.isAltraDataCheckedMalPeri = true;
          this.altraDataMalPeri = this.patientBodyStat.bodyStat.malattiaPerianaleCD[0].date.split(' ')[0];
        }
      } else {
        this.malperiYes = false;
        this.isDiagnosiDateCheckedMalPeri = false;
        this.isAltraDataCheckedMalPeri = false;
      }
      this.createFieldMalPeri(this.patientBodyStat.bodyStat.malattiaPerianaleCD[0].value, this.patientBodyStat.bodyStat.malattiaPerianaleCD[0].date);
    }
  }

  checkDataLocatColon() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.locatColonCD !== undefined && this.patientBodyStat.bodyStat.locatColonCD !== null && this.patientBodyStat.bodyStat.locatColonCD.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.locatColonCD = this.patientBodyStat.bodyStat.locatColonCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.locatColonCD[0].date !== null) {
        if (this.patientBodyStat.bodyStat.locatColonCD[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedLocatColon = true;
          this.isAltraDataCheckedLocatColon = false;
        } else {
          this.isDiagnosiDateCheckedLocatColon = false;
          this.isAltraDataCheckedLocatColon = true;
          this.altraDataLocatColon = this.patientBodyStat.bodyStat.locatColonCD[0].date.split(' ')[0];
        }
      } else {
        this.locatColonYes = false;
        this.isDiagnosiDateCheckedLocatColon = false;
        this.isAltraDataCheckedLocatColon = false;
      }
      this.createFieldLocatColon(this.patientBodyStat.bodyStat.locatColonCD[0].value, this.patientBodyStat.bodyStat.locatColonCD[0].date);
    }
  }

  checkDataLocatIleum() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.locatIleumCD !== undefined && this.patientBodyStat.bodyStat.locatIleumCD !== null && this.patientBodyStat.bodyStat.locatIleumCD.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.locatIleumCD = this.patientBodyStat.bodyStat.locatIleumCD.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.locatIleumCD[0].date !== null) {
        if (this.patientBodyStat.bodyStat.locatIleumCD[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedLocatIleum = true;
          this.isAltraDataCheckedLocatIleum = false;
        } else {
          this.isDiagnosiDateCheckedLocatIleum = false;
          this.isAltraDataCheckedLocatIleum = true;
          this.altraDataLocatIleum = this.patientBodyStat.bodyStat.locatIleumCD[0].date.split(' ')[0];
        }
      } else {
        this.locatIleumYes = false;
        this.isDiagnosiDateCheckedLocatIleum = false;
        this.isAltraDataCheckedLocatIleum = false;
      }
      this.createFieldLocatIleum(this.patientBodyStat.bodyStat.locatIleumCD[0].value, this.patientBodyStat.bodyStat.locatIleumCD[0].date);
    }
  }

  checkDataLocatUpperGI() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.locatUpperGI !== undefined && this.patientBodyStat.bodyStat.locatUpperGI !== null && this.patientBodyStat.bodyStat.locatUpperGI.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.locatUpperGI = this.patientBodyStat.bodyStat.locatUpperGI.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.locatUpperGI[0].date !== null) {
        if (this.patientBodyStat.bodyStat.locatUpperGI[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedLocatUpper = true;
          this.isAltraDataCheckedLocatUpper = false;
        } else {
          this.isDiagnosiDateCheckedLocatUpper = false;
          this.isAltraDataCheckedLocatUpper = true;
          this.altraDataLocatUpper = this.patientBodyStat.bodyStat.locatUpperGI[0].date.split(' ')[0];
        }
      } else {
        this.locatUpperYes = false;
        this.isDiagnosiDateCheckedLocatUpper = false;
        this.isAltraDataCheckedLocatUpper = false;
      }
      this.createFieldLocatUpper(this.patientBodyStat.bodyStat.locatUpperGI[0].value, this.patientBodyStat.bodyStat.locatUpperGI[0].date);
    }
  }

  checkDataLocalizzazioneUC() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.localizzazioneUC !== undefined && this.patientBodyStat.bodyStat.localizzazioneUC !== null && this.patientBodyStat.bodyStat.localizzazioneUC.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.localizzazioneUC = this.patientBodyStat.bodyStat.localizzazioneUC.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      // localizzazione UC ha sempre una data di riferimento
      if (this.patientBodyStat.bodyStat.localizzazioneUC[0].date !== null) {
        if (this.patientBodyStat.bodyStat.localizzazioneUC[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedLocUC = true;
          this.isAltraDataCheckedLocUC = false;
        } else {
          this.isDiagnosiDateCheckedLocUC = false;
          this.isAltraDataCheckedLocUC = true;
          this.altraDataLocUC = this.patientBodyStat.bodyStat.localizzazioneUC[0].date.split(' ')[0];
        }
      }
      this.createFieldLocUC(this.patientBodyStat.bodyStat.localizzazioneUC[0].value, this.patientBodyStat.bodyStat.localizzazioneUC[0].date);
    }
  }

  checkDataStomia() {
    if (this.patientBodyStat.bodyStat.stomia !== undefined && this.patientBodyStat.bodyStat.stomia !== null && this.patientBodyStat.bodyStat.stomia.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.stomia = this.patientBodyStat.bodyStat.stomia.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.stomia[0].date !== null) {
        if (this.patientBodyStat.bodyStat.stomia[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedStomia = true;
          this.isAltraDataCheckedStomia = false;
        } else {
          this.isDiagnosiDateCheckedStomia = false;
          this.isAltraDataCheckedStomia = true;
          this.altraDataStomia = this.patientBodyStat.bodyStat.stomia[0].date.split(' ')[0];
        }
      } else {
        this.stomiaYes = false;
        this.isDiagnosiDateCheckedStomia = false;
        this.isAltraDataCheckedStomia = false;
      }
      this.createFieldStomia(this.patientBodyStat.bodyStat.stomia[0].value, this.patientBodyStat.bodyStat.stomia[0].date);
    }
  }

  checkDataStoriche() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.storicheEIMS !== undefined && this.patientBodyStat.bodyStat.storicheEIMS !== null && this.patientBodyStat.bodyStat.storicheEIMS.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.storicheEIMS = this.patientBodyStat.bodyStat.storicheEIMS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.storicheEIMS[0].date !== null) {
        if (this.patientBodyStat.bodyStat.storicheEIMS[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedStoriche = true;
          this.isAltraDataCheckedStoriche = false;
        } else {
          this.isDiagnosiDateCheckedStoriche = false;
          this.isAltraDataCheckedStoriche = true;
          this.altraDataStoriche = this.patientBodyStat.bodyStat.storicheEIMS[0].date.split(' ')[0];
        }
      } else {
        this.storicheYes = false;
        this.isDiagnosiDateCheckedStoriche = false;
        this.isAltraDataCheckedStoriche = false;
      }
      this.createFieldStoriche(this.patientBodyStat.bodyStat.storicheEIMS[0].value, this.patientBodyStat.bodyStat.storicheEIMS[0].date);
    }
  }

  checkDataAttive() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.attiveEIMS !== undefined && this.patientBodyStat.bodyStat.attiveEIMS !== null && this.patientBodyStat.bodyStat.attiveEIMS.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.attiveEIMS = this.patientBodyStat.bodyStat.attiveEIMS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.attiveEIMS[0].date !== null) {
        if (this.patientBodyStat.bodyStat.attiveEIMS[0].date.split(' ')[0] === this.patientBodyStat.bodyStat.dateOfDiagnosis) {
          this.isDiagnosiDateCheckedAttive = true;
          this.isAltraDataCheckedAttive = false;
        } else {
          this.isDiagnosiDateCheckedAttive = false;
          this.isAltraDataCheckedAttive = true;
          this.altraDataAttive = this.patientBodyStat.bodyStat.attiveEIMS[0].date.split(' ')[0];
        }
      } else {
        this.attiveYes = false;
        this.isDiagnosiDateCheckedAttive = false;
        this.isAltraDataCheckedAttive = false;
      }
      this.createFieldAttive(this.patientBodyStat.bodyStat.attiveEIMS[0].value, this.patientBodyStat.bodyStat.attiveEIMS[0].date);
    }
  }

  // funzioni per ritrovare l'ultimo valore inserito delle terapie
  checkData5ASAOS() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.therapy5ASAOS !== undefined && this.patientBodyStat.bodyStat.therapy5ASAOS !== null && this.patientBodyStat.bodyStat.therapy5ASAOS.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapy5ASAOS = this.patientBodyStat.bodyStat.therapy5ASAOS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.therapy5ASAOS[0].done === '1') {
        if (this.patientBodyStat.bodyStat.therapy5ASAOS[0].onGoing === '1') {
          this.fiveASAOSpast = true;
          this.fiveASAOSValue.done = '1';
          this.fiveASAOSpresent = true;
          this.fiveASAOSValue.onGoing = '1';
          this.last5ASAOSpast = 'si';
          this.last5ASAOSpresent = 'si';
          this.fiveASAOSValue.dateOfStart = this.patientBodyStat.bodyStat.therapy5ASAOS[0].dateOfStart;
          this.lastDateOfStart5ASA = this.fiveASAOSValue.dateOfStart.split(' ')[0];
        } else {
          this.fiveASAOSpast = true;
          this.fiveASAOSValue.done = '1';
          this.fiveASAOSpresent = false;
          this.fiveASAOSValue.onGoing = '0';
          this.last5ASAOSpast = 'si';
          this.last5ASAOSpresent = 'no';
          this.fiveASAOSValue.dateOfStart = null;
        }
      } else {
        this.fiveASAOSpast = false;
        this.last5ASAOSpast = 'no';
        this.fiveASAOSValue.done = '0';
        this.fiveASAOSpresent = false;
        this.fiveASAOSValue.onGoing = null;
        this.fiveASAOSValue.dateOfStart = null;
      }
    }
  }

  checkDataGCSOS() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.therapyGCSOS !== undefined && this.patientBodyStat.bodyStat.therapyGCSOS !== null && this.patientBodyStat.bodyStat.therapyGCSOS.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapyGCSOS = this.patientBodyStat.bodyStat.therapyGCSOS.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.therapyGCSOS[0].done === '1') {
        if (this.patientBodyStat.bodyStat.therapyGCSOS[0].onGoing === '1') {
          this.gcsPast = true;
          this.gcsOSValue.done = '1';
          this.gcsPresent = true;
          this.gcsOSValue.onGoing = '1';
          this.lastGCSOSpast = 'si';
          this.lastGCSOSpresent = 'si';
          this.gcsOSValue.dateOfStart = this.patientBodyStat.bodyStat.therapyGCSOS[0].dateOfStart;
          this.lastDateOfStartGCS = this.gcsOSValue.dateOfStart.split(' ')[0];
        } else {
          this.gcsPast = true;
          this.gcsOSValue.done = '1';
          this.gcsPresent = false;
          this.gcsOSValue.onGoing = '0';
          this.lastGCSOSpast = 'si';
          this.lastGCSOSpresent = 'no';
          this.gcsOSValue.dateOfStart = null;
        }
      } else {
        this.gcsPast = false;
        this.lastGCSOSpast = 'no';
        this.gcsOSValue.done = '0';
        this.gcsPresent = false;
        this.gcsOSValue.onGoing = null;
        this.gcsOSValue.dateOfStart = null;
      }
    }
  }

  checkDataTOPICA() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.therapyTOPICA !== undefined && this.patientBodyStat.bodyStat.therapyTOPICA !== null && this.patientBodyStat.bodyStat.therapyTOPICA.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapyTOPICA = this.patientBodyStat.bodyStat.therapyTOPICA.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.therapyTOPICA[0].done === '1') {
        if (this.patientBodyStat.bodyStat.therapyTOPICA[0].onGoing === '1') {
          this.topicaPast = true;
          this.topicaValue.done = '1';
          this.topicaPresent = true;
          this.topicaValue.onGoing = '1';
          this.lastTOPICApast = 'si';
          this.lastTOPICApresent = 'si';
          this.topicaValue.dateOfStart = this.patientBodyStat.bodyStat.therapyTOPICA[0].dateOfStart;
          this.lastDateOfStartTOPICA = this.topicaValue.dateOfStart.split(' ')[0];
        } else {
          this.topicaPast = true;
          this.topicaValue.done = '1';
          this.topicaPresent = false;
          this.topicaValue.onGoing = '0';
          this.lastTOPICApast = 'si';
          this.lastTOPICApresent = 'no';
          this.topicaValue.dateOfStart = null;
        }
      } else {
        this.topicaPast = false;
        this.lastTOPICApast = 'no';
        this.topicaValue.done = '0';
        this.topicaPresent = false;
        this.topicaValue.onGoing = null;
        this.topicaValue.dateOfStart = null;
      }
    }
  }

  checkDataIMM() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.therapyIMM !== undefined && this.patientBodyStat.bodyStat.therapyIMM !== null && this.patientBodyStat.bodyStat.therapyIMM.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapyIMM = this.patientBodyStat.bodyStat.therapyIMM.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.therapyIMM[0].done === '1') {
        if (this.patientBodyStat.bodyStat.therapyIMM[0].onGoing === '1') {
          this.immPast = true;
          this.immValue.done = '1';
          this.immPresent = true;
          this.immValue.onGoing = '1';
          this.lastIMMpast = 'si';
          this.lastIMMpresent = 'si';
          this.immValue.dateOfStart = this.patientBodyStat.bodyStat.therapyIMM[0].dateOfStart;
          this.lastDateOfStartIMM = this.immValue.dateOfStart.split(' ')[0];
        } else {
          this.immPast = true;
          this.immValue.done = '1';
          this.immPresent = false;
          this.immValue.onGoing = '0';
          this.lastIMMpast = 'si';
          this.lastIMMpresent = 'no';
          this.immValue.dateOfStart = null;
        }
      } else {
        this.immPast = false;
        this.lastIMMpast = 'no';
        this.immValue.done = '0';
        this.immPresent = false;
        this.immValue.onGoing = null;
        this.immValue.dateOfStart = null;
      }
    }
  }

  checkDataBIO() {
    // tslint:disable-next-line:max-line-length
    if (this.patientBodyStat.bodyStat.therapyBIO !== undefined && this.patientBodyStat.bodyStat.therapyBIO !== null && this.patientBodyStat.bodyStat.therapyBIO.length !== 0) {
      // tslint:disable-next-line:max-line-length
      this.patientBodyStat.bodyStat.therapyBIO = this.patientBodyStat.bodyStat.therapyBIO.slice().sort((n1, n2) => this.comparing(n1.dateInput, n2.dateInput));
      if (this.patientBodyStat.bodyStat.therapyBIO[0].done === '1') {
        if (this.patientBodyStat.bodyStat.therapyBIO[0].onGoing === '1') {
          this.bioPast = true;
          this.bioValue.done = '1';
          this.bioPresent = true;
          this.bioValue.onGoing = '1';
          this.lastBIOpast = 'si';
          this.lastBIOpresent = 'si';
          this.bioValue.dateOfStart = this.patientBodyStat.bodyStat.therapyBIO[0].dateOfStart;
          this.lastDateOfStartBIO = this.bioValue.dateOfStart.split(' ')[0];
        } else {
          this.bioPast = true;
          this.bioValue.done = '1';
          this.bioPresent = false;
          this.bioValue.onGoing = '0';
          this.lastBIOpast = 'si';
          this.lastBIOpresent = 'no';
          this.lastDateOfStartBIO = null;
        }
      } else {
        this.bioPast = false;
        this.lastBIOpast = 'no';
        this.bioValue.done = '0';
        this.bioValue.onGoing = null;
        this.bioValue.dateOfStart = null;
        this.bioPresent = false;
      }
    }
  }

  // quando annullo ripristino tutte le variabili allo stato iniziale di default
  annulla() {
    this.editing = false;
    window.location.reload();
    this.openSnackBar('Inserimento annullato con successo!', 'Chiudi');
  }

  openConfirmDialog() {
    // creo un testo che riepiloga i dati appena inseriti
    // serve per un'ulteriore conferma prima di invocare
    // la funzione sendData() che invia i dati al backend
    const altezza = 'Altezza: ' + this.formToSend.height;
    const peso = ' Peso: ' + this.formToSend.weight;
    const eta = ' Età: ' + this.formToSend.age;
    const sesso = ' Sesso: ' + this.convertValueSex(this.formToSend.sex);
    const pathology = ' Patologia: ' + this.formToSend.pathology;
    const dataDiagnosi = ' Data diagnosi: ' + this.formToSend.dateOfDiagnosis;
    const etaDiagnosi = ' Età alla diagnosi: ' + this.formToSend.ageOfDiagnosis;
    const durata = ' Durata patologia: ' + this.formToSend.pathologyDuration;
    const familiarita = ' Familiarità: ' + this.convertValue(this.formToSend.familiarity);
    const interventi = ' Interventi: ' + this.convertValue(this.formToSend.interventi);
    const numeroResezioni = ' Numero di resezioni: ' + this.formToSend.numResezioni;
    const stomia = ' Stomia: ' + this.convertValue(this.stomiaValue.value) + ',' + ' data: ' + this.stomiaValue.date;
    // tslint:disable-next-line:max-line-length
    const storicheEIMS = ' EIMS storiche: ' + this.convertValueStoriche(this.storicheEIMSValue.value) + ',' + ' data: ' + this.storicheEIMSValue.date;
    const attiveEIMS = ' EIMS attive: ' + this.convertValue(this.attiveEIMSValue.value) + ',' + ' data: ' + this.attiveEIMSValue.date;
    let gcsOS;
    let imm;
    let bio;
    let topica;
    let fiveASA;
    if (this.fiveASAOSValue.done === '1') {
      if (this.fiveASAOSValue.onGoing === '1') {
        fiveASA = '  5-ASA-OS: terapia effettuata e in corso, iniziata il ' + this.fiveASAOSValue.dateOfStart;
      } else {
        fiveASA = '  5-ASA-OS: terapia effettuata e conclusa nel passato';
      }
    } else {
      fiveASA = '  5-ASA-OS: terapia MAI effettuata';
    }
    if (this.gcsOSValue.done === '1') {
      if (this.gcsOSValue.onGoing === '1') {
        gcsOS = '  GCS-OS: terapia effettuata e in corso, iniziata il ' + this.gcsOSValue.dateOfStart;
      } else {
        gcsOS = '  GCS-OS: terapia effettuata e conclusa nel passato';
      }
    } else {
      gcsOS = '  GCS-OS: terapia MAI effettuata';
    }
    if (this.topicaValue.done === '1') {
      if (this.topicaValue.onGoing === '1') {
        topica = '  TOPICA : terapia effettuata e in corso, iniziata il ' + this.topicaValue.dateOfStart;
      } else {
        topica = '  TOPICA : terapia effettuata e conclusa nel passato';
      }
    } else {
      topica = '  TOPICA : terapia MAI effettuata';
    }
    if (this.bioValue.done === '1') {
      if (this.bioValue.onGoing === '1') {
        bio = '  BIO: terapia effettuata e in corso, iniziata il ' + this.bioValue.dateOfStart;
      } else {
        bio = '  BIO: terapia effettuata e conclusa nel passato';
      }
    } else {
      bio = '  BIO: terapia MAI effettuata';
    }
    if (this.immValue.done === '1') {
      if (this.immValue.onGoing === '1') {
        imm = '  IMM: terapia effettuata e in corso, iniziata il ' + this.immValue.dateOfStart;
      } else {
        imm = '  IMM: terapia effettuata e conclusa nel passato';
      }
    } else {
      imm = '  IMM: terapia MAI effettuata';
    }
    if (this.isPatientCrohn === true) {
      // tslint:disable-next-line:max-line-length
      const infiammatorio = ' Infiammatorio: ' + this.convertValue(this.infiammatorioCDValue.value) + ',' + ' data: ' + this.infiammatorioCDValue.date;
      const stenosante = ' Stenosante: ' + this.convertValue(this.stenosanteCDValue.value) + ',' + ' data: ' + this.stenosanteCDValue.date;
      const penetrante = ' Penetrante: ' + this.convertValue(this.penetranteCDValue.value) + ',' + ' data: ' + this.penetranteCDValue.date;
      // tslint:disable-next-line:max-line-length
      const malPeri = ' Malattia perianale: ' + this.convertValue(this.malattiaPerianaleCDValue.value) + ',' + ' data: ' + this.malattiaPerianaleCDValue.date;
      const locColon = ' Locat Colon: ' + this.convertValue(this.locatColonCDValue.value) + ',' + ' data: ' + this.locatColonCDValue.date;
      const locIleum = ' Locat Ileum: ' + this.convertValue(this.locatIleumCDValue.value) + ',' + ' data: ' + this.locatIleumCDValue.date;
      // tslint:disable-next-line:max-line-length
      const locUpper = ' Locat Upper GI: ' + this.convertValue(this.locatUpperGIValue.value) + ',' + ' data: ' + this.locatUpperGIValue.date;
      /*this.riepilogo = altezza + peso + eta + sesso + pathology + dataDiagnosi +
        etaDiagnosi + durata + familiarita + interventi + numeroResezioni +
        storicheEIMS + attiveEIMS + infiammatorio + stenosante + penetrante +
      malPeri + locIleum + locColon + locUpper + fiveASA + gcsOS + topica + imm + bio;*/
      this.riepilogo = [
        'Se confermata, questa operazione non potrà più essere annullata!',
        'Se annullata, sarà necessario procedere con un nuovo inserimento',
        'Riepilogo dei dati appena inseriti:', altezza, peso, eta, sesso, pathology, dataDiagnosi, etaDiagnosi, durata, familiarita,
        interventi, numeroResezioni, stomia, storicheEIMS, attiveEIMS,
        infiammatorio, stenosante, penetrante, malPeri,
        locIleum, locColon, locUpper, fiveASA,
        gcsOS, topica, imm, bio];
    } else {
      // tslint:disable-next-line:max-line-length
      const localizzUC = ' Localizzazione UC: ' + this.convertValueLocalizzazioneUC(this.localizzazioneUCValue.value) + ',' + ' data: ' + this.localizzazioneUCValue.date;
      /*this.riepilogo = altezza + peso + eta + sesso + pathology + dataDiagnosi +
        etaDiagnosi + durata + familiarita + interventi + numeroResezioni +
        storicheEIMS + attiveEIMS + localizzUC + fiveASA + gcsOS + topica + imm + bio;*/
      this.riepilogo = [
        'Se confermata, questa operazione non potrà più essere annullata',
        'Se annullata, sarà necessario procedere con un nuovo inserimento',
        'Riepilogo dei dati appena inseriti:', altezza, peso, eta, sesso, pathology, dataDiagnosi,
        etaDiagnosi, durata, familiarita, interventi, numeroResezioni, stomia,
        storicheEIMS, attiveEIMS, localizzUC, fiveASA, gcsOS, topica, imm, bio];
    }
    // tslint:disable-next-line:max-line-length
    const message = this.riepilogo;
    const dialogRef = this.dialog.open(ConfirmDialogMultilinesComponent, {
      width: '50%',
      height: '90%',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'SI') {
        this.sendData();
      } else {
        this.openSnackBar('Operazione annullata con successo!', 'Chiudi');
        // i seguenti servono per inserire la data di input del valore
        if (this.isPatientCrohn === true) {
          this.patientBodyStat.bodyStat.infiammatorioCD.pop();
          this.patientBodyStat.bodyStat.stenosanteCD.pop();
          this.patientBodyStat.bodyStat.penetranteCD.pop();
          this.patientBodyStat.bodyStat.malattiaPerianaleCD.pop();
          this.patientBodyStat.bodyStat.locatColonCD.pop();
          this.patientBodyStat.bodyStat.locatIleumCD.pop();
          this.patientBodyStat.bodyStat.locatUpperGI.pop();
        }
        // per UC e IBD_U
        if (this.isPatientUC === true) {
          this.patientBodyStat.bodyStat.localizzazioneUC.pop();
        }
        // per tutti
        this.patientBodyStat.bodyStat.storicheEIMS.pop();
        this.patientBodyStat.bodyStat.attiveEIMS.pop();
        this.patientBodyStat.bodyStat.stomia.pop();
        // terapia: inizializzazione delle variabili
        this.patientBodyStat.bodyStat.therapy5ASAOS.pop();
        this.patientBodyStat.bodyStat.therapyTOPICA.pop();
        this.patientBodyStat.bodyStat.therapyGCSOS.pop();
        this.patientBodyStat.bodyStat.therapyIMM.pop();
        this.patientBodyStat.bodyStat.therapyBIO.pop();
        // notes and therapies
        // tslint:disable-next-line:max-line-length
        if ((this.statForm.value.notes !== null && this.statForm.value.notes !== '')) {
          this.patientBodyStat.bodyStat.notes.pop();
        }
        // tslint:disable-next-line:max-line-length
        if ((this.statForm.value.therapies !== null && this.statForm.value.therapies !== '')) {
          this.patientBodyStat.bodyStat.therapies.pop();
        }
        // creazione della statForm che verrà inviata al BE
        this.formToSend = new StatForm(this.patientBodyStat.bodyStat.weight, this.patientBodyStat.bodyStat.height, this.patientBodyStat.bodyStat.age,
          this.patientBodyStat.bodyStat.sex, this.patientBodyStat.bodyStat.dateOfDiagnosis, this.patientBodyStat.bodyStat.ageOfDiagnosis,
          this.patientBodyStat.bodyStat.familiarity, this.patientBodyStat.bodyStat.pathologyDuration, this.patientBodyStat.bodyStat.pathology,
          this.patientBodyStat.bodyStat.notes, this.patientBodyStat.bodyStat.therapies, this.patientBodyStat.bodyStat.infiammatorioCD,
          this.patientBodyStat.bodyStat.stenosanteCD, this.patientBodyStat.bodyStat.penetranteCD,
          this.patientBodyStat.bodyStat.malattiaPerianaleCD, this.patientBodyStat.bodyStat.locatColonCD, this.patientBodyStat.bodyStat.locatIleumCD,
          this.patientBodyStat.bodyStat.locatUpperGI, this.patientBodyStat.bodyStat.localizzazioneUC, this.patientBodyStat.bodyStat.storicheEIMS,
          this.patientBodyStat.bodyStat.attiveEIMS, this.patientBodyStat.bodyStat.interventi, this.patientBodyStat.bodyStat.numResezioni,
          this.patientBodyStat.bodyStat.stomia, this.patientBodyStat.bodyStat.therapy5ASAOS, this.patientBodyStat.bodyStat.therapyTOPICA,
          this.patientBodyStat.bodyStat.therapyGCSOS,
          this.patientBodyStat.bodyStat.therapyIMM, this.patientBodyStat.bodyStat.therapyBIO);
        this.delay(200).then(anything => {
          window.location.reload();
        });
      }
    });
  }

  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }
}
